define('viewmodels/configuration/RiskLevel',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'], function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'RiskLevel';

    var RlViewModel = {
        title: title,
        activate: activate,
        attached: attached,
        detached: detached,
        logger: logger,
        appsecurity: appsecurity,
        ControlsAccess: ko.observable(false),
        addPopUpCss: ko.observable(true),
        addPopUpCtrlCss: ko.observable(false),
        PageType: ko.observable(),
        //--------------Start of Declaration of Model Objects For IRS Tab--------------------------------
        LabelForinherentrisk: ko.observable(),
        LabelForFinalRiskLevel: ko.observable(),
        IRSDataList: ko.observableArray([]),
        IRSDataList1: ko.observableArray([]),
        IRSDataList2: ko.observableArray([]),
        IRSDataList3: ko.observableArray([]),
        IRSDataList3Dup: ko.observableArray([]),
        IRSDataListQuant: ko.observableArray([]),
        IRSDataListQuantDup: ko.observableArray([]),
        IRSDataListDup: ko.observableArray([]),
        IRSDataList1Dup: ko.observableArray([]),
        IRSDataList2Dup: ko.observableArray([]),
        IRSDataListDup1: ko.observableArray([]),
        IRRSDataList: ko.observableArray([]),
        IRRSDataList1: ko.observableArray([]),
        IRRSDataListDup: ko.observableArray([]),
        IRRSDataListDup1: ko.observableArray([]),
        IRSSaveButton: IRSSaveButton,
        IRSDeleteSetupButton: IRSDeleteSetupButton,
        IRSDeleteButton: IRSDeleteButton,
        IRSCancelButton: IRSCancelButton,
        QualitativeRiskLevelList: ko.observableArray([]),
        LabelForinherentriskQuant: ko.observable(),
        csssample: ko.observable('heatmap-green'),



        //--------------Start of Declaration of Model Objects For CRS Tab--------------------------------
        CRSDataList: ko.observableArray([]),
        CRSDataListDup: ko.observableArray([]),
        CRSColorPaletteList: ko.observableArray([]),
        CRSAddButton: CRSAddButton,
        InhAddButton: InhAddButton,
        InhSetupDeleteButton: InhSetupDeleteButton,
        CRSDeleteButton: CRSDeleteButton,
        CRSDeleteSetupButton: CRSDeleteSetupButton,
        CRSDeleteSetupScale: CRSDeleteSetupScale,
        CRSSetupDeleteButton: CRSSetupDeleteButton,
        CRSCancelButton: CRSCancelButton,
        CRSSaveButton: CRSSaveButton,
        SetCRSOptionsClass: SetCRSOptionsClass,
        SetRiskColorValue: SetRiskColorValue,
        FirstId: ko.observable(),
        CRSEditButton: CRSEditButton,
        InhDeleteButton: InhDeleteButton,
        ControlResponseTypeList: ko.observableArray([]),
        SelectedControlsResponseType: ko.observableArray([]),
        FinalCheckBoxClick: FinalCheckBoxClick,

        //--------------Start of Declaration of Model Objects For RRS Tab--------------------------------

        RRSDataList: ko.observableArray([]),
        RRSDataListDup: ko.observableArray([]),
        RRSMasterDataList: ko.observableArray([]),
        RRSDrpDwnChange: RRSDrpDwnChange,
        RRSSaveButton: RRSSaveButton,
        RRSCancelButton: RRSCancelButton,
        RRSSetupEditButton: RRSSetupEditButton,
        StdAppLevelList: ko.observableArray([]),
        //----
        RRSSetupDataList: ko.observableArray([]),
        RRSSetupDataListDup: ko.observableArray([]),
        RRSSetupAddButton: RRSSetupAddButton,
        RRSSetupSaveButton: RRSSetupSaveButton,
        RRSSetupDeleteButton: RRSSetupDeleteButton,
        RRSSetupDeleteScaleButton: RRSSetupDeleteScaleButton,
        RRSSetupDeleteScale: RRSSetupDeleteScale,
        RRSSetupCancelButton: RRSSetupCancelButton,
        AddNewRRSLevelCount: ko.observable(-1),
        residualcountEntry: ko.observable(false),
        SetResidualRiskColorValue: SetResidualRiskColorValue,
        SetResidualMatrixRiskColorValue: SetResidualMatrixRiskColorValue,
        //--------------Start of Declaration of Model OResidualbjects For QRS Tab--------------------------------
        forIRSFlag: ko.observable(1),
        forCRSFlag: ko.observable(1),
        ImagePathList: ko.observableArray([]),
        countEntry: ko.observable(false),
        controlcountEntry: ko.observable(false),
        countResidualEntry: ko.observable(false),
        imagePath: ko.observable(),
        AddNewLevelCount: ko.observable(-1),
        RiskLevelTabClick: RiskLevelTabClick,
        ReadyToClick: ko.observable(true),
        LabelForImpact: ko.observable(),
        SetControlRiskColorValue: SetControlRiskColorValue,

        //Variables and methods Open Popup
        IRSCreateButton: IRSCreateButton,
        editaleRiskLevel: ko.observable(),
        popUpTitle: ko.observable(),
        saveRiskLevelPopup: saveRiskLevelPopup,
        InherentRiskLevelList: ko.observableArray([]),
        IRSEditButton: IRSEditButton,
        ClickType: ko.observable(),
        InherentRiskLevelListDup: ko.observableArray([]),
        ControlsRiskLevelListDup: ko.observableArray([]),
        ControlsRiskLevelList: ko.observableArray([]),
        ResidualRiskLevelList: ko.observableArray([]),
        ResidualRiskLevelListDup: ko.observableArray([]),
        AssessmentTypeList: ko.observableArray([]),
        AssessmentTypeClick: AssessmentTypeClick,
        ClickedAssessmentTypeId: ko.observable(),
        ActionChanged: ActionChanged,
        ActionChangedCSS: ActionChangedCSS,
        IRSAddMatrixButton: IRSAddMatrixButton,
        CMRCreateButton: CMRCreateButton,
        MatrixAxisList: ko.observableArray(),
        AddResidualMatrix: ko.observable(false),
        AddInherentMatrix: ko.observable(false),
        AddControlMatrix: ko.observable(false),
        residualScale: ko.observable(),
        InherentScale: ko.observable(),
        ControlScale: ko.observable(),
        ResidualScaleList: ko.observableArray(),
        InherentScaleList: ko.observableArray(),
        ControlScaleList: ko.observableArray(),
        saveResidualRiskMatrixPopup: saveResidualRiskMatrixPopup,
        saveInherentRiskMatrixPopup: saveInherentRiskMatrixPopup,
        MasterMatrixRiskLevelList: ko.observableArray([]),
        MasterMatrixRiskLevelListDup: ko.observableArray([]),
        InherentMasterMatrixRiskLevelList: ko.observableArray([]),
        InherentMasterMatrixRiskLevelListDup: ko.observableArray([]),
        ControlMasterMatrixRiskLevelList: ko.observableArray([]),
        ControlMasterMatrixRiskLevelListDup: ko.observableArray([]),
        ResidualLevelsDropdownList: ko.observableArray(),
        SetRESOptionsClass: SetRESOptionsClass,
        RRMatrixData: ko.observableArray(),
        RRMatrixSaveButton: RRMatrixSaveButton,
        INHMatrixSaveButton: INHMatrixSaveButton,
        INHMatrixDeleteButton: INHMatrixDeleteButton,
        RRMatrixDeleteButton: RRMatrixDeleteButton,
        INHMatrixDeleteSetupButton: INHMatrixDeleteSetupButton,
        INHMatrixEditSetupButton: INHMatrixEditSetupButton,
        RRMatrixDeleteSetupButton: RRMatrixDeleteSetupButton,
        SelectedScoreMatrix: ko.observableArray(),
        InherentSelectedScoreMatrix: ko.observableArray(),
        MinValueBlur: MinValueBlur,
        ChangeInScoringType: ChangeInScoringType,
        MinValueClick: MinValueClick,
        EditableInherentScale: ko.observable(),
        EditableResidualScale: ko.observable(),
        EditableControlScale: ko.observable(),
        EditInherentRiskMatrixPopup: EditInherentRiskMatrixPopup,
        EditResidualRiskMatrixPopup: EditResidualRiskMatrixPopup,
        RRMatrixDEditSetupButton: RRMatrixDEditSetupButton,
        ScaleType: ko.observable(),
        MaxValueBlur: MaxValueBlur,
        CRSAddMatrixButton: CRSAddMatrixButton,
        saveControlMatrixPopup: saveControlMatrixPopup,
        CTRLMatrixSaveButton: CTRLMatrixSaveButton,
        ControlSelectedScoreMatrix: ko.observableArray(),
        CTRLMatrixEditSetupButton: CTRLMatrixEditSetupButton,
        EditControlRiskMatrixPopup: EditControlRiskMatrixPopup,
        CTRLMatrixDeleteSetupButton: CTRLMatrixDeleteSetupButton,
        CTRLMatrixCancelSetupButton: CTRLMatrixCancelSetupButton,
        INHRMatrixCancelSetupButton: INHRMatrixCancelSetupButton,
        ChangePercent: ChangePercent,
        ChangePercentEdit: ChangePercentEdit,
        MaxCheckDecimal: MaxCheckDecimal,
        MinCheckDecimal: MinCheckDecimal,
        SurveyCategoryList: ko.observableArray([]),
        SelectedSurveyCategoriesList: ko.observableArray([]),
        IsEditRiskLevel: ko.observable(),
        IsRowDelete: ko.observable(false)

        //--------------End of Declaration of Model Objects For CRS Tab--------------------------------

    };

    return RlViewModel;

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(5)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            GetAllAssessmentTypes();
            ko.bindingHandlers['uniqueName'].currentIndex = 0;
            RlViewModel.countEntry(false);
            RlViewModel.controlcountEntry(false);
            RlViewModel.countResidualEntry(false);
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        RlViewModel.ControlsAccess(true);
                    }
                    else {
                        RlViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (RlViewModel.appsecurity.WriteAccess() && !appsecurity.isConfigurationFreeze()) {
                RlViewModel.ControlsAccess(true);
            }
            else {
                RlViewModel.ControlsAccess(false);
            }
            GetStandardApplicationLevels();

            $($(document.getElementsByClassName('list-group-item')).get(5)).addClass('active');
            $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');

            $('#tblCRS tbody').on('blur', "#txtControlMin1", function (event) {
                MinValueBlur(event);
            });
            $('#tblCRS tbody').on('click', "#txtControlMin1", function (event) {
                PreviousMaxValue = event.currentTarget.value;
            });

            $(document.body).on('blur', '#txtResidual', function (event) {
                saveRRSValues(event);
            });

            $($('#RiskLevelTab li').get(0)).trigger('click');

            /*Global dropdown events*/
            $(window).resize(function (e) {
                closeAllRiskColorDropDowns(e);
                closeAllResidualRiskColorDropDowns(e);
                closeAllResidualMatrixRiskColorDropDowns(e);
                closeAllControlRiskColorDropDowns(e);
            });
            $('#Masterdiv').scroll(function (e) {
                closeAllRiskColorDropDowns(e);
                closeAllResidualRiskColorDropDowns(e);
                closeAllResidualMatrixRiskColorDropDowns(e);
                closeAllControlRiskColorDropDowns(e);
            });
            $(document).scroll(function (e) {
                closeAllRiskColorDropDowns(e);
                closeAllResidualRiskColorDropDowns(e);
                closeAllResidualMatrixRiskColorDropDowns(e);
                closeAllControlRiskColorDropDowns(e);
            });
            $(document).mousedown(function (e) {
                closeAllRiskColorDropDowns(e);
                closeAllResidualRiskColorDropDowns(e);
                closeAllResidualMatrixRiskColorDropDowns(e);
                closeAllControlRiskColorDropDowns(e);
            });

            /*End (Global dropdown events)*/

            /*Risk color dropdown events*/
            $('#RiskLevelTab').on('mouseup', '.risk-color-clickable', function (event) {
                var element;
                if ($(this).hasClass('selected-risk-color')) {
                    element = $(this);
                } else {
                    element = $(this).next('.selected-risk-color');
                }
                SetStartingPosition(element);
                ExpandOnlySelectedMenu(element);
            });
            /*End (Risk color dropdown events)*/

            /*Residual risk color dropdown events*/
            $('#RiskLevelTab').on('mouseup', '.residual-risk-color-clickable', function (event) {
                var element;
                if ($(this).hasClass('residual-selected-risk-color')) {
                    element = $(this);
                } else {
                    element = $(this).next('.residual-selected-risk-color');
                }
                SetStartingPositionResidual(element);
                ExpandOnlySelectedMenuResidual(element);
            });
            /*End (Residual risk color dropdown events)*/

            /*Residual matrix risk color dropdown events*/
            $('#RiskLevelTab').on('mouseup', '.residual-matrix-risk-color-clickable', function (event) {
                var element;
                if ($(this).hasClass('residual-matrix-selected-risk-color')) {
                    element = $(this);
                } else {
                    element = $(this).next('.residual-matrix-selected-risk-color');
                }
                HandleResidualMatrixMouseupEvent(element);
            });
            /*End (Residual matrix risk color dropdown events)*/

            /*Control risk color dropdown events*/
            $('#RiskLevelTab').on('mouseup', '.control-risk-color-clickable', function (event) {
                var element;
                if ($(this).hasClass('control-selected-risk-color')) {
                    element = $(this);
                } else {
                    element = $(this).next('.control-selected-risk-color');
                }
                SetStartingPositionControl(element);
                ExpandOnlySelectedMenuControl(element);
            });
            /*End (Control risk color dropdown events)*/
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetSurveyCategories(AssessmentTypeId) {
        try {
            $.ajax({
                url: "/api/Configuration/GetSurveyCategoryTabsByAssessmentType",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "AssessmentId": AssessmentTypeId, "ScreenType": "RS" }
            })
                .success(function (jsonResult, success) {
                    try {
                        if (jsonResult != null) {
                            var mappedList = $.map(jsonResult, function (result) {
                                return new SurveyCategoryModel(result);
                            });
                            RlViewModel.SurveyCategoryList(mappedList);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: GetSurveyCategories() Success method in RiskLevel.js';
                        logger.logMessage(msg);
                    }

                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategories() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategories() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function closeAllRiskColorDropDowns(e) {
        try {
            var theWrapper = $(".risk-color-dropdown-wrapper");
            var theIcon = $(".inherent-risk-color-arrow");
            var theDiv = $(".selected-risk-color");

            var wrapperNotClicked = false;
            var iconNotClicked = false;
            var divNotClicked = false;
            //Not the element or it's descendants
            if (!theWrapper.is(e.target) && theWrapper.has(e.target).length === 0) {
                wrapperNotClicked = true;
            }

            //Not the element or it's descendants
            if (!theIcon.is(e.target) && theIcon.has(e.target).length === 0) {
                iconNotClicked = true;
            }

            //Not the element or it's descendants
            if (!theDiv.is(e.target) && theDiv.has(e.target).length === 0) {
                divNotClicked = true;
            }

            if (wrapperNotClicked && iconNotClicked && divNotClicked)
                HandlecloseAllRiskColorDropDowns();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closeAllRiskColorDropDowns() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function closeAllResidualRiskColorDropDowns(e) {
        try {
            var theWrapper = $(".residual-risk-color-dropdown-wrapper");
            var theIcon = $(".residual-risk-color-arrow");
            var theDiv = $(".residual-selected-risk-color");

            var wrapperNotClicked = false;
            var iconNotClicked = false;
            var divNotClicked = false;
            //Not the element or it's descendants
            if (!theWrapper.is(e.target) && theWrapper.has(e.target).length === 0) {
                wrapperNotClicked = true;
            }

            //Not the element or it's descendants
            if (!theDiv.is(e.target) && theDiv.has(e.target).length === 0) {
                divNotClicked = true;
            }

            //Not the element or it's descendants
            if (!theIcon.is(e.target) && theIcon.has(e.target).length === 0) {
                iconNotClicked = true;
            }
            if (wrapperNotClicked && iconNotClicked && divNotClicked)
                HandlecloseAllResidualRiskColorDropDowns();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closeAllResidualRiskColorDropDowns() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function closeAllResidualMatrixRiskColorDropDowns(e) {
        try {
            var theWrapper = $(".residual-matrix-risk-color-dropdown-wrapper");
            var theIcon = $(".residual-matrix-risk-color-arrow");
            var theDiv = $(".residual-matrix-selected-risk-color");

            var wrapperNotClicked = false;
            var iconNotClicked = false;
            var divNotClicked = false;
            //Not the element or it's descendants
            if (!theWrapper.is(e.target) && theWrapper.has(e.target).length === 0) {
                wrapperNotClicked = true;
            }

            //Not the element or it's descendants
            if (!theDiv.is(e.target) && theDiv.has(e.target).length === 0) {
                divNotClicked = true;
            }

            //Not the element or it's descendants
            if (!theIcon.is(e.target) && theIcon.has(e.target).length === 0) {
                iconNotClicked = true;
            }

            if (wrapperNotClicked && iconNotClicked && divNotClicked)
                HandlecloseAllResidualMatrixRiskColorDropDowns();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closeAllResidualMatrixRiskColorDropDowns() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function closeAllControlRiskColorDropDowns(e) {
        try {
            var theWrapper = $(".control-risk-color-dropdown-wrapper");
            var theIcon = $(".control-risk-color-arrow");
            var theDiv = $(".control-selected-risk-color");

            var wrapperNotClicked = false;
            var iconNotClicked = false;
            var divNotClicked = false;
            //Not the element or it's descendants
            if (!theWrapper.is(e.target) && theWrapper.has(e.target).length === 0) {
                wrapperNotClicked = true;
            }

            //Not the element or it's descendants
            if (!theIcon.is(e.target) && theIcon.has(e.target).length === 0) {
                iconNotClicked = true;
            }

            //Not the element or it's descendants
            if (!theDiv.is(e.target) && theDiv.has(e.target).length === 0) {
                divNotClicked = true;
            }

            if (wrapperNotClicked && iconNotClicked && divNotClicked)
                HandlecloseAllControlRiskColorDropDowns();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: closeAllControlRiskColorDropDowns() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function HandlecloseAllRiskColorDropDowns() {
        try {
            $('.risk-color-dropdown-wrapper').each(function () {
                if (!$(this).hasClass('risk-color-hide')) {
                    $(this).addClass('risk-color-hide')
                }
            });

            $('.risk-color-arrow').each(function () {
                if ($(this).hasClass('risk-color-arrow-up')) {
                    $(this).removeClass('risk-color-arrow-up');
                    $(this).addClass('risk-color-arrow-down');
                }
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HandlecloseAllRiskColorDropDowns() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function HandlecloseAllResidualMatrixRiskColorDropDowns() {
        try {
            $('.residual-matrix-risk-color-dropdown-wrapper').each(function () {
                if (!$(this).hasClass('risk-color-hide')) {
                    $(this).addClass('risk-color-hide')
                }
            });

            $('.residual-matrix-selected-risk-color').each(function () {
                if ($(this).hasClass('currently-active')) {
                    $(this).removeClass('currently-active')
                }
            });

            $('.risk-color-arrow').each(function () {
                if ($(this).hasClass('risk-color-arrow-up')) {
                    $(this).removeClass('risk-color-arrow-up');
                    $(this).addClass('risk-color-arrow-down');
                }
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HandlecloseAllResidualMatrixRiskColorDropDowns() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function HandleResidualMatrixMouseupEvent(element) {
        try {
            $('.residual-matrix-risk-color-dropdown-wrapper').addClass('risk-color-hide');
            var arrow = element.parent().children('.risk-color-arrow').first();

            if (element.hasClass('currently-active'))//the element was clicked before
            {
                element.removeClass('currently-active');
                arrow.removeClass('risk-color-arrow-up');
                arrow.addClass('risk-color-arrow-down');
            } else {
                //the current element is not trying to close the dropdown so...

                //1. Remove the flag if it's applied somewhere else
                $('.residual-matrix-selected-risk-color').each(function () {
                    if ($(this).hasClass('currently-active')) {
                        $(this).removeClass('currently-active')
                    }
                })

                $('.risk-color-arrow').each(function () {
                    if ($(this).hasClass('risk-color-arrow-up')) {
                        $(this).removeClass('risk-color-arrow-up');
                        $(this).addClass('risk-color-arrow-down');
                    }
                })

                arrow.addClass('risk-color-arrow-up');

                //2. set the flag on the element is currently active
                element.addClass('currently-active');

                //3. We always show the same set of options so choose the proper position
                SetResidualMatrixRiskColorDropdownStartingPosition(element);

                //4. Display
                $('.residual-matrix-risk-color-dropdown-wrapper').removeClass('risk-color-hide');
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HandleResidualMatrixMouseupEvent() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function HandlecloseAllResidualRiskColorDropDowns() {
        try {
            $('.residual-risk-color-dropdown-wrapper').each(function () {
                if (!$(this).hasClass('risk-color-hide')) {
                    $(this).addClass('risk-color-hide')
                }
            });

            $('.risk-color-arrow').each(function () {
                if ($(this).hasClass('risk-color-arrow-up')) {
                    $(this).removeClass('risk-color-arrow-up');
                    $(this).addClass('risk-color-arrow-down');
                }
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HandlecloseAllResidualRiskColorDropDowns() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function HandlecloseAllControlRiskColorDropDowns() {
        try {
            $('.control-risk-color-dropdown-wrapper').each(function () {
                if (!$(this).hasClass('risk-color-hide')) {
                    $(this).addClass('risk-color-hide')
                }
            });

            $('.risk-color-arrow').each(function () {
                if ($(this).hasClass('risk-color-arrow-up')) {
                    $(this).removeClass('risk-color-arrow-up');
                    $(this).addClass('risk-color-arrow-down');
                }
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: HandlecloseAllControlRiskColorDropDowns() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetStartingPosition(element) {
        try {
            var top = element.offset().top;
            var wrapperHeight = element.next('.risk-color-dropdown-wrapper').outerHeight(true);
            var documentHeight = $('#main-wrapper').outerHeight(true);

            var wrapperAbsBottom = top + wrapperHeight + 30;

            var inputHeight = element.outerHeight(true);

            if (documentHeight < wrapperAbsBottom) {
                element.next('.risk-color-dropdown-wrapper').css('top', 'auto', 'important');
                element.next('.risk-color-dropdown-wrapper').css('bottom', inputHeight, 'important');
            } else {
                element.next('.risk-color-dropdown-wrapper').css('bottom', 'auto', 'important');
                element.next('.risk-color-dropdown-wrapper').css('top', inputHeight, 'important');
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetStartingPosition() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetStartingPositionResidual(element) {
        try {
            var top = element.offset().top;
            var wrapperHeight = element.next('.residual-risk-color-dropdown-wrapper').outerHeight(true);
            var documentHeight = $('#main-wrapper').outerHeight(true);

            var wrapperAbsBottom = top + wrapperHeight + 30;

            var inputHeight = element.outerHeight(true);

            if (documentHeight < wrapperAbsBottom) {
                element.next('.residual-risk-color-dropdown-wrapper').css('top', 'auto', 'important');
                element.next('.residual-risk-color-dropdown-wrapper').css('bottom', inputHeight, 'important');
            } else {
                element.next('.residual-risk-color-dropdown-wrapper').css('bottom', 'auto', 'important');
                element.next('.residual-risk-color-dropdown-wrapper').css('top', inputHeight, 'important');
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetStartingPositionResidual() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetResidualMatrixRiskColorDropdownStartingPosition(element) {
        try {
            var optionsWrapper = $('.residual-matrix-risk-color-dropdown-wrapper');

            var offsetTop = 0;
            var offsetLeft = 0;
            var dropdownWidth = 0;
            var wrapperHeight = 0;
            var documentHeight = 0;
            offsetTop = element.offset().top;
            offsetLeft = element.offset().left;

            dropdownWidth = optionsWrapper.outerWidth(true);
            wrapperHeight = optionsWrapper.outerHeight(true);
            documentHeight = $('#main-wrapper').outerHeight(true);

            var calculatedOffsetTop = 0;
            calculatedOffsetTop = offsetTop - wrapperHeight;
            var inputHeight = 0;
            inputHeight = element.outerHeight(true);

            //remove the attribute otherwise the values add up
            optionsWrapper.removeAttr("style");

            optionsWrapper.css('position', 'fixed', '!important');
            optionsWrapper.offset({ top: calculatedOffsetTop, left: offsetLeft });
            console.log(dropdownWidth);
            optionsWrapper.css('width', dropdownWidth, 'important');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetResidualMatrixRiskColorDropdownStartingPosition() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetStartingPositionControl(element) {
        try {
            var top = element.offset().top;
            var wrapperHeight = element.next('.control-risk-color-dropdown-wrapper').outerHeight(true);
            var documentHeight = $('#main-wrapper').outerHeight(true);

            var wrapperAbsBottom = top + wrapperHeight + 30;

            var inputHeight = element.outerHeight(true);

            if (documentHeight < wrapperAbsBottom) {
                element.next('.control-risk-color-dropdown-wrapper').css('top', 'auto', 'important');
                element.next('.control-risk-color-dropdown-wrapper').css('bottom', inputHeight, 'important');
            } else {
                element.next('.control-risk-color-dropdown-wrapper').css('bottom', 'auto', 'important');
                element.next('.control-risk-color-dropdown-wrapper').css('top', inputHeight, 'important');
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetStartingPositionControl() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ExpandOnlySelectedMenu(element) {
        try {
            var isOpening = element.next('.risk-color-dropdown-wrapper').hasClass('risk-color-hide');
            var arrow = element.parent().children('.risk-color-arrow').first();

            if (isOpening) {
                $('.risk-color-dropdown-wrapper').each(function () {
                    if (!$(this).hasClass('risk-color-hide')) {
                        $(this).addClass('risk-color-hide')
                    }
                })

                $('.risk-color-arrow').each(function () {
                    if ($(this).hasClass('risk-color-arrow-up')) {
                        $(this).removeClass('risk-color-arrow-up');
                        $(this).addClass('risk-color-arrow-down');
                    }
                })

                arrow.addClass('risk-color-arrow-up');
                element.next('.risk-color-dropdown-wrapper').removeClass('risk-color-hide');
            } else {
                element.next('.risk-color-dropdown-wrapper').addClass('risk-color-hide');
                arrow.removeClass('risk-color-arrow-up');
                arrow.addClass('risk-color-arrow-down');
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ExpandOnlySelectedMenu() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ExpandOnlySelectedMenuResidual(element) {
        try {
            var isOpening = element.next('.residual-risk-color-dropdown-wrapper').hasClass('risk-color-hide');
            var arrow = element.parent().children('.risk-color-arrow').first();

            if (isOpening) {
                $('.residual-risk-color-dropdown-wrapper').each(function () {
                    if (!$(this).hasClass('risk-color-hide')) {
                        $(this).addClass('risk-color-hide')
                    }
                })

                $('.risk-color-arrow').each(function () {
                    if ($(this).hasClass('risk-color-arrow-up')) {
                        $(this).removeClass('risk-color-arrow-up');
                        $(this).addClass('risk-color-arrow-down');
                    }
                })

                arrow.addClass('risk-color-arrow-up');
                element.next('.residual-risk-color-dropdown-wrapper').removeClass('risk-color-hide');
            } else {
                element.next('.residual-risk-color-dropdown-wrapper').addClass('risk-color-hide');
                arrow.removeClass('risk-color-arrow-up');
                arrow.addClass('risk-color-arrow-down');
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ExpandOnlySelectedMenuResidual() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ExpandOnlySelectedMenuControl(element) {
        try {
            var isOpening = element.next('.control-risk-color-dropdown-wrapper').hasClass('risk-color-hide');
            var arrow = element.parent().children('.risk-color-arrow').first();

            if (isOpening) {
                $('.control-risk-color-dropdown-wrapper').each(function () {
                    if (!$(this).hasClass('risk-color-hide')) {
                        $(this).addClass('risk-color-hide')
                    }
                })

                $('.risk-color-arrow').each(function () {
                    if ($(this).hasClass('risk-color-arrow-up')) {
                        $(this).removeClass('risk-color-arrow-up');
                        $(this).addClass('risk-color-arrow-down');
                    }
                })

                arrow.addClass('risk-color-arrow-up');
                element.next('.control-risk-color-dropdown-wrapper').removeClass('risk-color-hide');
            } else {
                element.next('.control-risk-color-dropdown-wrapper').addClass('risk-color-hide');
                arrow.removeClass('risk-color-arrow-up');
                arrow.addClass('risk-color-arrow-down');
            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ExpandOnlySelectedMenuControl() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentTypeClick(data, event) {
        try {

            $($('#RiskLevelUL li').get(0)).trigger('click');
            RlViewModel.ClickedAssessmentTypeId(parseInt(event.currentTarget.id));
            GetSurveyCategories(RlViewModel.ClickedAssessmentTypeId());
            $('#AssessmentUl li').removeClass('active');
            $('#' + event.currentTarget.id).addClass('active');
            $('#tabsInherent').hide();
            $('#tabsInherentRiskLevel').hide();
            $('#tabsControl').hide();
            $('#tabsResidual').hide();
            $('#residualAccordion').hide();
            $('#tabsResidualSetup').hide();

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentTypeClick() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ActionChangedCSS(data, event) {
        try {
            var className = event.currentTarget.className.substring("form-control".length + 1, event.currentTarget.className.length)

            $(event.currentTarget).removeClass(className)
            $(event.currentTarget).addClass(event.currentTarget.selectedOptions[0].className);
            $(event.currentTarget).removeAttr('style');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ActionChanged(data, event) {
        try {
            var className = event.currentTarget.className.substring("form-control".length + 1, event.currentTarget.className.length)
            $(event.currentTarget).removeClass(className)
            $(event.currentTarget).addClass(event.currentTarget.value);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function GetAllAssessmentTypes() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAssessmentTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()

            })
                .success(function (jsonResult, error) {
                    RlViewModel.AssessmentTypeList([]);
                    if (jsonResult != null) {


                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            return new AssessmentListModel(result);
                        });
                        RlViewModel.AssessmentTypeList(MappedAssessmentList);
                        $($('#AssessmentUl li').get(0)).trigger('click');
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(HmViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetAllInherentLevels() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllInherentLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllInherentLevels() method in RiskLevel.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 0 || jsonResult == null) {

                    $('#NoDataErrorInherent').show();
                    document.getElementById('tabsInherent').innerHTML = "";
                    $('#NoDataErrorControls').hide();
                    $('#NoDataErrorResidual').hide();
                    var element = $('#InherentCrossMatrix')[0];
                    ko.cleanNode(element);
                    $('#InherentCrossMatrix').html("");
                }
                else {
                    $('#NoDataErrorInherent').hide();
                    $('#NoDataErrorControls').hide();
                    $('#NoDataError').hide();
                    $('#NoDataErrorResidual').hide();
                    var mappedIRSData = $.map(jsonResult, function (result) {
                        return new RiskLevelModel(result);
                    });
                    var mappedIRSDataDup = $.map(jsonResult, function (result) {
                        return new RiskLevelModel(result);
                    });
                    document.getElementById('tabsInherent').innerHTML = "";
                    RlViewModel.InherentRiskLevelList([]);
                    RlViewModel.InherentRiskLevelListDup(mappedIRSDataDup);
                    RlViewModel.InherentRiskLevelList(mappedIRSData);
                    BindDynamicHtml();
                    GetAllRiskLevelInherentMatrix();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllInherentLevels() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllInherentLevels() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in GetAllInherentLevels() method in RiskLevel.js';
                logger.logMessage(msg);
            }

        };
    }

    function GetAllResidualLevels() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetAllResidualLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == 0 || JsonResult == null) {
                        $('#NoDataErrorControls').hide();
                        $('#NoDataErrorInherent').hide();
                        $('#NoDataErrorResidual').show();
                        document.getElementById('tabsResidual').innerHTML = "";
                        $('#residualAccordion').hide();
                    }
                    else {
                        $('#NoDataErrorInherent').hide();
                        $('#NoDataErrorControls').hide();
                        $('#NoDataError').hide();
                        $('#NoDataErrorResidual').hide();
                        var mappedResidualData = $.map(JsonResult, function (result) {
                          return new ResidualParentRiskLevelModel(result);
                        });
                        var mappedResidualDataDup = $.map(JsonResult, function (result) {
                            return new ResidualParentRiskLevelModel(result);
                        });
                        var element = $('#tabsResidual')[0];
                        ko.cleanNode(element);
                        $('#tabsResidual').html("");
                        RlViewModel.ResidualRiskLevelList(mappedResidualData);
                        RlViewModel.ResidualRiskLevelListDup(mappedResidualDataDup);
                        BindDynamicHtmlForResdiualRatingLevel();

                        if (RlViewModel.ResidualRiskLevelList().length > 0) {
                            RlViewModel.AddResidualMatrix(true);
                            $('#crossMatrixBtn').show();
                        }

                        //Get Master risk level matrix if any
                        GetAllRiskLevelMatrix();
                    }
                })
                .fail(function (JsonResult, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: GetAllResidualLevels() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllResidualLevels() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetMasterLevelsInherent() {
        try {
            $.ajax({
                url: "/api/Configuration/GetMasterLevelsInherent",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == 0 || JsonResult == null) {
                        $('#NoDataErrorInherent').show();
                    }
                    else {
                        $('#NoDataErrorInherent').hide();
                        $('#NoDataErrorControls').hide();
                        $('#NoDataError').hide();
                        $('#NoDataErrorResidual').hide();
                        if (JsonResult.CombinedRiskLevelList.length > 0) {
                            var mappedFirstList = $.map(JsonResult.CombinedRiskLevelList, function (result) {
                                return new AxisModel({ AxisId: result.RiskLevelId, AxisName: result.RiskLevelName });
                            });
                            RlViewModel.MatrixAxisList(mappedFirstList);
                        }
                        if (JsonResult.InherentRiskLevelList.length > 0) {
                            //Residual dropdown list
                            var mappedList = $.map(JsonResult.InherentRiskLevelList, function (result) {
                                return new AxisModel({ AxisId: result.RiskLevelId, AxisName: result.RiskLevelName });
                            });
                            RlViewModel.InherentScaleList(mappedList);
                        }
                    }
                })
                .fail(function (JsonResult, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: GetMasterLevelsInherent() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetMasterLevelsInherent() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetMasterLevelsControl() {
        try {
            var ControlList = [], FinalList = [];
            for (var i = 0; i < RlViewModel.ControlsRiskLevelList().length; i++) {
                if (RlViewModel.ControlsRiskLevelList()[i].Type == 'Control') {
                    ControlList.push(RlViewModel.ControlsRiskLevelList()[i]);
                }
                else {
                    FinalList.push(RlViewModel.ControlsRiskLevelList()[i]);
                }
            }
            var mappedModel = $.map(ControlList, function (result) {
                return new AxisModel({ AxisId: result.RiskLevelId, AxisName: result.RiskLevelName });
            });
            RlViewModel.MatrixAxisList(mappedModel);
            mappedModel = $.map(FinalList, function (result) {
                return new AxisModel({ AxisId: result.RiskLevelId, AxisName: result.RiskLevelName });
            });
            RlViewModel.ControlScaleList(mappedModel);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetMasterLevelsControl() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetMasterLevels() {
        try {
            $.ajax({
                url: "/api/Configuration/GetMasterLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == 0 || JsonResult == null) {
                        $('#NoDataErrorResidual').show();
                    }
                    else {
                        $('#NoDataErrorInherent').hide();
                        $('#NoDataErrorControls').hide();
                        $('#NoDataError').hide();
                        $('#NoDataErrorResidual').hide();
                        if (JsonResult.CombinedRiskLevelList.length > 0) {
                            var mappedFirstList = $.map(JsonResult.CombinedRiskLevelList, function (result) {
                                return new AxisModel({ AxisId: result.RiskLevelId, AxisName: result.RiskLevelName });
                            });
                            RlViewModel.MatrixAxisList(mappedFirstList);
                        }
                        if (JsonResult.ResidualSubList.length > 0) {
                            //Residual dropdown list
                            var mappedList = $.map(JsonResult.ResidualSubList, function (result) {
                                return new AxisModel({ AxisId: result.RRLId, AxisName: result.RRLName });
                            });
                            RlViewModel.ResidualScaleList(mappedList);
                        }
                    }
                })
                .fail(function (JsonResult, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: GetMasterLevels() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetMasterLevels() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskLevelMatrix() {
        try {

            $.ajax({
                url: "/api/Configuration/GetAllRiskLevelMatrix",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == 0 || JsonResult == null) {
                        var element = $('#residualCrossMatrix')[0];
                        ko.cleanNode(element); 
                        $('#residualCrossMatrix').html("");
                        RlViewModel.MasterMatrixRiskLevelList([]);
                        RlViewModel.MasterMatrixRiskLevelListDup([]);
                        $('#NoDataErrorMatrix').show();
                    }
                    else {
                        $('#NoDataErrorMatrix').hide();
                        //X-axis list
                        var mappedAxisLevelData = $.map(JsonResult, function (result) {
                            return new MasterParentRiskMatrixModel(result);
                        });
                        var element = $('#residualCrossMatrix')[0];
                        ko.cleanNode(element);
                        $('#residualCrossMatrix').html("");
                        RlViewModel.MasterMatrixRiskLevelList(mappedAxisLevelData);
                        RlViewModel.MasterMatrixRiskLevelListDup(mappedAxisLevelData);

                        BindDynamicHtmlForMasterMatrixRatingLevel();
                    }
                })
                .fail(function (JsonResult, status) {
                    if (status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: | Source: GetAllRiskLevelMatrix() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskLevelMatrix() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskLevelInherentMatrix() {
        try {

            $.ajax({
                url: "/api/Configuration/GetAllRiskLevelInherentMatrix",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(function (JsonResult, status) {

                    if (JsonResult == 0 || JsonResult == null) {
                        $('#NoDataErrorMatrix').show();
                        document.getElementById('InherentCrossMatrix').innerHTML = "";
                    }
                    else {
                        $('#NoDataErrorMatrix').hide();
                        //X-axis list
                        var mappedAxisLevelData = $.map(JsonResult, function (result) {
                            return new InherentMasterParentRiskMatrixModel(result);
                        });
                        var element = $('#InherentCrossMatrix')[0];
                        ko.cleanNode(element);
                        $('#InherentCrossMatrix').html("");
                        RlViewModel.InherentMasterMatrixRiskLevelList([]);
                        RlViewModel.InherentMasterMatrixRiskLevelList(mappedAxisLevelData);
                        RlViewModel.InherentMasterMatrixRiskLevelListDup(mappedAxisLevelData);
                        //FOR INHERENT MATRIX HTML
                        BindDynamicHtmlForInherentMasterMatrixRatingLevel();
                    }
                })
                .fail(function (JsonResult, status) {


                    if (status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: | Source: GetAllRiskLevelInherentMatrix() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {


            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskLevelInherentMatrix() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskLevelControlMatrix() {
        try {

            $.ajax({
                url: "/api/Configuration/GetAllRiskLevelControlMatrix",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(function (JsonResult, status) {

                    if (JsonResult == 0 || JsonResult == null) {
                        var element = $('#ControlCrossMatrix')[0];
                        ko.cleanNode(element);
                        RlViewModel.ControlMasterMatrixRiskLevelList([]);
                        document.getElementById('ControlCrossMatrix').innerHTML = "";
                    }
                    else {

                        //X-axis list
                        var mappedAxisLevelData = $.map(JsonResult, function (result) {
                            return new ControlMasterParentRiskMatrixModel(result);
                        });
                        var element = $('#ControlCrossMatrix')[0];
                        ko.cleanNode(element);
                        $('#ControlCrossMatrix').html("");
                        RlViewModel.ControlMasterMatrixRiskLevelList(mappedAxisLevelData);
                        RlViewModel.ControlMasterMatrixRiskLevelListDup(mappedAxisLevelData);
                        //FOR CONTROL MATRIX HTML
                        BindDynamicHtmlForControlMasterMatrixRatingLevel();
                    }
                })
                .fail(function (JsonResult, status) {


                    if (status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: | Source: GetAllRiskLevelControlMatrix() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {


            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllRiskLevelControlMatrix() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetAllControlsLevels() {
        try {
            var ele = document.getElementById('tabsControl');
            ko.cleanNode(ele);
            RlViewModel.ControlsRiskLevelList([]);
            $.ajax({
                url: "/api/Configuration/GetAllControlsLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetAllControlsLevels() method in RiskLevel.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == 0 || jsonResult == null) {
                    $('#NoDataErrorControls').show();
                    document.getElementById('tabsControl').innerHTML = "";
                }
                else {
                    $('#NoDataErrorInherent').hide();
                    $('#NoDataErrorControls').hide();
                    $('#NoDataError').hide();
                    $('#NoDataErrorResidual').hide();
                    $('#loadingMainImgDiv').hide();
                    var mappedControlsData = $.map(jsonResult, function (result) {
                        return new ControlsParentRiskLevelModel(result);
                    });
                    RlViewModel.ControlsRiskLevelListDup(mappedControlsData);
                    var mappedControlsDataDup = $.map(jsonResult, function (result) {
                        return new ControlsParentRiskLevelModel(result);
                    });
                    RlViewModel.ControlsRiskLevelList(mappedControlsDataDup);
                    BindDynamicHtmlforControls();
                    GetAllRiskLevelControlMatrix();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetAllInherentLevels() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllControlsLevels() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxFail in GetAllControlsLevels() method in RiskLevel.js';
                logger.logMessage(msg);
            }

        };
    }

    function BindDynamicHtmlForResdiualRatingLevel() {
        try {
            var DynamicHTML = "";

            for (var i = 0; i < RlViewModel.ResidualRiskLevelList().length; i++) {


                DynamicHTML += ' <div class="d-flex">' +
                    '<div class="no-padding"><label class="control-label"> Name: ' + RlViewModel.ResidualRiskLevelList()[i].RRLName + '</label> <i class="fa fa-edit mr-1" id="Edit' + RlViewModel.ResidualRiskLevelList()[i].RRLId + '" data-bind="click: $root.RRSSetupEditButton"></i></div>' +
                    '<div class="btn-group-sm pull-right ml-auto" data-bind="if: ($root.ControlsAccess())">' +
                    '<button id="Add' + RlViewModel.ResidualRiskLevelList()[i].RRLId + '" data-bind="click: $root.RRSSetupAddButton" class="primary-btn mt-1 mr-1 mb-1" type="submit">' +
                    '<i class="fa fa-plus mr-1"></i>' +
                    'Add' +
                    '</button>' +
                    '<button id="Save' + RlViewModel.ResidualRiskLevelList()[i].RRLId + '" data-bind="click: $root.RRSSetupSaveButton" class="primary-btn mt-1 mb-1" type="submit">' +
                    '   <i class="fa fa-check mr-1"></i>' +
                    'Save' +
                    '</button>' +
                    ' <button id="Cancel' + RlViewModel.ResidualRiskLevelList()[i].RRLId + '" data-bind="click: $root.RRSSetupCancelButton" class="secondary-btn mt-1 mb-1" type="submit">' +
                    ' <i class="fa fa-times mr-1"></i>' +
                    'Cancel' +
                    '  </button>' +
                    ' <button id="Delete' + RlViewModel.ResidualRiskLevelList()[i].RRLId + '" data-bind="click: $root.RRSSetupDeleteScaleButton" class="secondary-btn mt-1 mb-1" type="submit">' +
                    ' <i class="fa fa-trash-o mr-1"></i>' +
                    'Delete Scale' +
                    '  </button>' +
                    '  </div>' +
                    '</div>';
                var id = 'ResidualRiskLevelList()[' + i + '].MappedRiskLevels';

                DynamicHTML += '<div class="row-fluid">' +
                    ' <label class="alert alert-danger col-xs-12 col-sm-12 col-md-12 col-lg-12" style="display:none" id="lblRRSCommonValidation">*required</label>' +
                    ' <div>' +
                    ' <table id="tblRRSSetup' + RlViewModel.ResidualRiskLevelList()[i].RRLId + '" class="table table-bordered  table-condensed risklevel_tables no-padding no-padding-right" >' +
                    ' <thead>' +
                    '<tr>' +
                    '<th style="width: 12%" class="text-center">' +
                    '   <label>Residual Risk Score</label>' +
                    '  </th>' +
                    '<th style="width: 16%" class="text-center">' +
                    '   <label>Residual Rating Color</label>' +
                    '  </th>' +
                    ' <th style="width: 20%;" class="text-center">' +
                    '   <label>Description</label>' +
                    ' </th>' +
                    ' <th style="width: 7%;" class="text-center">' +
                    '   <label>Short Name</label>' +
                    ' </th>' +
                    ' <th style="width: 10%;" class="text-center">' +
                    '   <label>Rating Adjustment</label>' +
                    ' </th>' +
                    '<th style="width: 40%" class="text-center">' +
                    ' <label>Definition</label>' +
                    '  </th>' +

                    '<th class="width: 7%" "text-center">' +
                    '<label>Action</label>' +
                    '</th>' +
                    '</tr>' +

                    '</thead>' +
                    '<tbody data-bind="foreach:' + id + '">' +

                    '<tr>' +

                    '<td style="text-align: center">' +
                    '<input class="form-control" id="ResidualLevelScore" name="ResidualLevels" data-bind="value: RRLRiskScore, css:{disabled: (!$root.ControlsAccess())}"></input>' +
                    '</td>' +

                    '<td id="RRSSetupDropDownID" data-bind="css:{disabled: (!$root.ControlsAccess())}">' +
                    '<div class="residual-risk-color-wrapper">' +
                    '<span class="risk-color-arrow residual-risk-color-arrow risk-color-arrow-down residual-risk-color-clickable"></span>' +
                    '<div data-bind="value: CSS, text: CSS || \'Pick a color\', css: CSS" class="residual-selected-risk-color residual-risk-color-clickable"></div>' +


                    '<div data-bind="foreach: $root.CRSColorPaletteList" class="residual-risk-color-dropdown-wrapper risk-color-hide">' +
                    '<div data-bind="text: RiskLevelCSS, css: RiskLevelCSS, click: $root.SetResidualRiskColorValue" class="residual-risk-color-selectable"></div>' +
                    '</div>' +
                    '</div>' +
                    '</td>' +

                    ' <td>' +
                    '<textarea id="txtResidualDescription" class="form-control" data-bind="value: Description, css:{disabled: (!$root.ControlsAccess())}" placeholder="Please enter a Description" rows="2" cols="30"></textarea>' +
                    '  <label class="field-validation-error" style="display:none" id="lblRRSDescValidation">*required</label>' +
                    '   </td>' +

                    '<td>' +
                    '<textarea class="form-control" id="txtShortName" name="Short Name" data-bind="value: RiskLevelShortName, css:{disabled: (!$root.ControlsAccess())}"></textarea>' +
                    '</td>' +

                    '<td>' +
                    '<textarea class="form-control" id="txtRatingAdj" name="Rating Adjustment" data-bind="value: RiskLevelAdj, css:{disabled: (!$root.ControlsAccess())}"></textarea>' +
                    '</td>' +

                    '<td>'+
                    '<textarea id="txtResidualComment" class="form-control" data-bind="value: Comments, css:{disabled: (!$root.ControlsAccess())}" placeholder="Please enter a Comment" rows="2" cols="80"></textarea>' +
                    '</td>' +

                    '<td class="text-center">' +
                    '<a id=' + RlViewModel.ResidualRiskLevelList()[i].RRLId + ' href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.RRSSetupDeleteButton, css:{disabled: (!$root.ControlsAccess())}">' +
                    '<div data-bind="if:Id">' +
                    '<i class="demo-icon icon-bin_special"></i>' +
                    '</div>' +
                    ' </a>' +
                    '</td>' +

                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +

                    '</div>';
            }
            document.getElementById("tabsResidual").innerHTML = "";
            document.getElementById("tabsResidual").innerHTML = DynamicHTML;
            var element = $('#tabsResidual')[0];
            ko.cleanNode(element);
            ko.applyBindings(RlViewModel, document.getElementById('tabsResidual'));
            $('#tabsResidual').show();
            $("#tabsResidual").removeClass('ui-widget-content');
            $('#residualAccordion').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in BindDynamicHtmlForResdiualRatingLevel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlForMasterMatrixRatingLevel() {
        try {
            var DynamicHTML = "";
            var rowf = 1;
            for (var i = 0; i < RlViewModel.MasterMatrixRiskLevelList().length; i++) {
                var residualMatrixName = RlViewModel.MasterMatrixRiskLevelList()[i].ResidualMatrixName;
                var residualMatrixId = RlViewModel.MasterMatrixRiskLevelList()[i].ResidualMatrixId;
                rowf = 1;
                DynamicHTML += '<div class="d-flex">' +
                    '<div class="col-xs-2 col-sm-2 col-md-2 col-lg-4 no-padding">' +
                    '<label class="control-label">Name: ' + residualMatrixName + '</label>  <i class="fa fa-edit mr-1" id="Edit-' + residualMatrixId + '"data-bind="click: $root.RRMatrixDEditSetupButton"></i ></div>' +
                    '<div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">' +
                    '<label id="lblvalidation" class="alert alert-danger " hidden="hidden"></label>' +
                    '</div>' +
                    '<div class="btn-group-sm pull-right ml-auto" data-bind="if: ($root.ControlsAccess())">' +
                    '<button id="Save-' + residualMatrixId + '" class="primary-btn mr-1 mt-1" data-bind="click: $root.RRMatrixSaveButton">' +
                    '<i class="fa fa-check mr-1"></i>' +
                    'Save' +
                    '</button>' +
                    '<button id="Cancel-' + residualMatrixId + '" class="secondary-btn mr-1 mt-1" data-bind="click: $root.RRSCancelButton">' +
                    '<i class="fa fa-times mr-1"></i>' +
                    'Cancel' +
                    '</button>' +
                    '<button id="Delete-' + residualMatrixId + '" class="secondary-btn mr-1 mt-1" data-bind="click: $root.RRMatrixDeleteSetupButton">' +
                    '<i class="fa fa-trash-o mr-1"></i>' +
                    'Delete Scale' +
                    '</button>' +
                    '<label class="field-validation-error" style="display:none" id="lblOverallValidation">' + '*required' + '</label>' +
                    '</div>' +
                    '</div>';
                console.log(RlViewModel.MasterMatrixRiskLevelList()[i]);
                var XAxisLevels = RlViewModel.MasterMatrixRiskLevelList()[i].XAxisLevels();
                var YAxisLevels = RlViewModel.MasterMatrixRiskLevelList()[i].YAxisLevels();

                var XAxisName = "";
                if (RlViewModel.MasterMatrixRiskLevelList()[i].XAxisType == 'CTRL')
                    XAxisName = "Controls Assessment";
                else
                    XAxisName = "Inherent Risk";

                var YAxisName = "";
                if (RlViewModel.MasterMatrixRiskLevelList()[i].YAxisType == 'CTRL')
                    YAxisName = "Controls Assessment";
                else
                    YAxisName = "Inherent Risk"

                var AxisName = YAxisName + ' / ' + XAxisName;

                DynamicHTML +=
                    '<div id="RRSMapping">' +
                    '<div>' +
                    '<div class="overflow-auto w-100">' +
                    '<table style="width:100% !important;" id="tblRRS' + residualMatrixId + '" class="table table-condensed risklevel_tables no-padding no-padding-right">' +
                    '<thead>' +
                    '<tr><th colspan="2" class="ResHeader borderclass"></th><th class ="text-center ResidualHeaders matrxHeader" data-bind ="attr:{colspan :' + (XAxisLevels.length) + '}">' + XAxisName + '</th></tr>';



                DynamicHTML += '</tr></thead>' +
                    '<tbody><tr><td class="ResHeader-wborder" colspan="2"><div class="ResHeader-text">Residual Risk Determination</div></td>';

                for (var j1 = 0; j1 < XAxisLevels.length; j1++) {
                    DynamicHTML += '<td  class="text-center ResidualHeadersRows residual-text-alignment" id="1">' + XAxisLevels[j1].LevelName() + '</td>';
                }
                DynamicHTML += '</tr>';
                for (var k = 0; k < YAxisLevels.length; k++) {

                    DynamicHTML += '<tr>';
                    if (rowf == 1) {
                        DynamicHTML += '<td class="matrxHeader" data-bind ="attr:{rowspan :' + (YAxisLevels.length) + '}">' + YAxisName + '</td>';
                        rowf++;
                    }
                    DynamicHTML += '<td id="' + YAxisLevels[k].LevelId() + '" class="ResidualHeadersRows Rvalues residual-text-alignment">';
                    if (YAxisLevels[k].LowerBound() != "" && YAxisLevels[k].UpperBound() != "") {
                        if (YAxisLevels[k].LowerBound() === "0" || YAxisLevels[k].LowerBound() === "0%") {
                            DynamicHTML += '<span style="display:block"> < ' + YAxisLevels[k].UpperBound() + '</span>';
                        }
                        else {
                            DynamicHTML += '<span style="display:block">' + YAxisLevels[k].LowerBound() + ' - ' + YAxisLevels[k].UpperBound() + '</span>';

                        }
                    }
                        DynamicHTML += '<span> ' + YAxisLevels[k].LevelName() + '</span ></td >';

                    for (var f = 0; f < XAxisLevels.length; f++) {
                        DynamicHTML += '<td class="text-center" style="width:110px">';
                        var bUnitId = 'ResidualDDYX_' + YAxisLevels[k].LevelId() + '_' + XAxisLevels[f].LevelId();

                        DynamicHTML += '<div class="residual-matrix-risk-color-wrapper" data-buid="' + bUnitId + '" data-currentCss="" data-levelid="">' +
                            '<span class="risk-color-arrow risk-color-arrow-down residual-matrix-risk-color-clickable"></span>' +
                            '<div class="residual-matrix-selected-risk-color residual-matrix-risk-color-clickable"></div>' +

                            '<div data-bind="foreach: MasterMatrixRiskLevelList()[' + i + '].ReisdualLevels()" class="residual-matrix-risk-color-dropdown-wrapper risk-color-hide">' +
                            '<div data-bind="text: LevelName, css: RiskCSS, value: LevelId, click: $root.SetResidualMatrixRiskColorValue" class="residual-matrix-risk-color-selectable"></div>' +
                            '</div>' +
                            '</div>';

                        DynamicHTML += '</td>';

                    }
                    DynamicHTML += '</tr>';
                }


                DynamicHTML += '</tbody>' + '</table>' + '</div>' + '</div>' + '</div>';

            }
            document.getElementById("residualCrossMatrix").innerHTML = "";
            document.getElementById("residualCrossMatrix").innerHTML = DynamicHTML;
            var element = $('#residualCrossMatrix')[0];
            ko.cleanNode(element);
            ko.applyBindings(RlViewModel, document.getElementById('residualCrossMatrix'));

            //Map selected residual score to dropdowns if any
            for (var p = 0; p < RlViewModel.MasterMatrixRiskLevelList().length; p++) {

                if (RlViewModel.MasterMatrixRiskLevelList()[p].ReisdualSectedLevelList().length > 0) {
                    var itemList = RlViewModel.MasterMatrixRiskLevelList()[p].ReisdualSectedLevelList();
                    var levelsList = RlViewModel.MasterMatrixRiskLevelList()[p].ReisdualLevels();
                    for (var f = 0; f < itemList.length; f++) {
                        //Current selection
                        var textToApply = "NA";
                        for (var index = 0; index < levelsList.length; index++) {
                            if (levelsList[index].LevelId === itemList[f].ResidualAxisId) {
                                textToApply = levelsList[index].LevelName;
                            }
                        }
                        var valueToApply = itemList[f].ResidualAxisId;

                        var clsToApply = itemList[f].RiskCSS;
                        var dataSelector = 'ResidualDDYX_' + itemList[f].YAxisId + '_' + itemList[f].XAxisId;

                        var currentDropDownWrapper = $('*[data-buid="' + dataSelector + '"]');
                        var currentDropDownSelection = $(currentDropDownWrapper.find('div.residual-matrix-selected-risk-color'));

                        currentDropDownWrapper.data('currentcss', clsToApply);
                        currentDropDownWrapper.data('levelid', valueToApply);
                        console.log(currentDropDownWrapper.data('levelid'));
                        currentDropDownSelection.addClass(clsToApply);
                        currentDropDownSelection.text(textToApply);
                    }
                }
            }
            $('#Residualaccordion').show();
            $('#residualCrossMatrix').show();
            $('#residualCrossMatrixAccordion').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in BindDynamicHtmlForMasterMatrixRatingLevel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlForInherentMasterMatrixRatingLevel() {
        try {
            var DynamicHTML = "";

            for (var i = 0; i < RlViewModel.InherentMasterMatrixRiskLevelList().length; i++) {
                var inherentMatrixName = RlViewModel.InherentMasterMatrixRiskLevelList()[i].InherentMatrixName;
                var inherentMatrixId = RlViewModel.InherentMasterMatrixRiskLevelList()[i].InherentMatrixId;
                var rowf = 1;
                DynamicHTML +=
                    '<div class="d-flex">' +
                    '<div class="no-padding">' +
                    '<label class="control-label">Name: ' + inherentMatrixName + '</label> <i class="fa fa-edit mr-1" id="Edit-' + inherentMatrixId + '"data-bind="click: $root.INHMatrixEditSetupButton"></i></div>' +
                    '<div class="col-lg-4">' +
                    '<label id="lblvalidation" class="alert alert-danger " hidden="hidden">' + '</label>' +
                    '</div>' +
                    '<div class="btn-group-sm pull-right ml-auto" data-bind="if: ($root.ControlsAccess())">' +
                    '<button id="Save-' + inherentMatrixId + '" class="primary-btn mr-1 mt-1" data-bind="click: $root.INHMatrixSaveButton">' +
                    '<i class="fa fa-check mr-1"></i>' +
                    'Save' +
                    '</button>' +
                    '<button id="Cancel-' + inherentMatrixId + '" class="secondary-btn mr-1 mt-1" data-bind="click:$root.INHRMatrixCancelSetupButton">' +
                    '<i class="fa fa-times mr-1"></i>' +
                    'Cancel' +
                    '</button>' +
                    '<button id="Delete-' + inherentMatrixId + '" class="secondary-btn mr-1 mt-1" data-bind="click: $root.INHMatrixDeleteSetupButton">' +
                    '<i class="fa fa-trash-o mr-1"></i>' +
                    'Delete Scale' +
                    '</button>' +


                    '<label class="field-validation-error" style="display:none" id="lblOverallValidation">' + '*required' + '</label>' +
                    '</div>' +
                    '</div>';

                var XAxisLevels = RlViewModel.InherentMasterMatrixRiskLevelList()[i].XAxisLevels();
                var YAxisLevels = RlViewModel.InherentMasterMatrixRiskLevelList()[i].YAxisLevels();


                var XAxisName = "";
                XAxisName = " " + RlViewModel.InherentMasterMatrixRiskLevelList()[i].XAxisName + " ";

                var YAxisName = "";
                YAxisName = RlViewModel.InherentMasterMatrixRiskLevelList()[i].YAxisName + " ";
                var AxisName = XAxisName + ' / ' + YAxisName;

                DynamicHTML +=
                    '<div id="INHMapping" class="overflow-auto">' +

                '<table style="width:100% !important;" id="tblINH' + inherentMatrixId + '" class="table table-condensed risklevel_tables no-padding no-padding-right">' +
                    '<thead>' +
                    '<tr>' +
                    '<th class="bg-white borderclass"></th><th class="bg-white borderclass"></th><th class ="text-center ResidualHeaders matrxHeader" data-bind ="attr:{colspan :' + (XAxisLevels.length) + '}">' + XAxisName + '</th>';


                DynamicHTML += '</tr>' + '</thead>' + '<tbody><tr><td class="bg-white borderclass"></td><td class="bg-white borderclass"></td>';
                for (var j = 0; j < XAxisLevels.length; j++) {
                    DynamicHTML += '<td class="text-center ResidualHeadersRows residual-text-alignment" id="1">' + XAxisLevels[j].LevelName() + '</td>';
                }
                DynamicHTML += '</tr>'
                for (var k = 0; k < YAxisLevels.length; k++) {
                    DynamicHTML +=
                        '<tr>';
                    if (rowf == 1) {
                        DynamicHTML += '<td class="matrxHeader" data-bind ="attr:{rowspan :' + (YAxisLevels.length) + '}">' + YAxisName + '</td>';
                        rowf++;
                    }

                    DynamicHTML += '<td id="' + YAxisLevels[k].LevelId() + '" class="text-center ResidualHeadersRows residual-text-alignment InherentMasterMatrixRatingAlign">' + YAxisLevels[k].LevelName() + '</td>';
                    for (var f = 0; f < XAxisLevels.length; f++) {
                        DynamicHTML +=
                            '<td class="text-center" >' +
                            '<select id="InherentDDYX_' + YAxisLevels[k].LevelId() + '_' + XAxisLevels[f].LevelId() + '" class="form-control1 dark-grey" data-bind="options: $root.InherentMasterMatrixRiskLevelList()[' + i + '].InherentLevels(), optionsText : \'LevelName\', optionsValue: \'LevelId\',optionsAfterRender: $root.SetRESOptionsClass, css: \'RiskCSS\', value: \'RiskCSS\', event: {change: $root.ActionChangedCSS}">' + '</select>' +
                            '</td>';

                    }
                    DynamicHTML += '</tr>';
                }

                DynamicHTML += '</tbody>' + '</table>' + '</div>';

            }
            document.getElementById("InherentCrossMatrix").innerHTML = "";
            document.getElementById("InherentCrossMatrix").innerHTML = DynamicHTML;
            var element = $('#InherentCrossMatrix')[0];
            ko.cleanNode(element);
            ko.applyBindings(RlViewModel, document.getElementById('InherentCrossMatrix'));

            //Map selected residual score to dropdowns if any
            for (var p = 0; p < RlViewModel.InherentMasterMatrixRiskLevelList().length; p++) {
                if (RlViewModel.InherentMasterMatrixRiskLevelList()[p].InherentLevels().length > 0) {
                    for (var m = 0; m < RlViewModel.InherentMasterMatrixRiskLevelList()[p].YAxisLevels().length; m++) {
                        for (var k = 0; k < RlViewModel.InherentMasterMatrixRiskLevelList()[p].XAxisLevels().length; k++) {
                            for (var c = 0; c < RlViewModel.InherentMasterMatrixRiskLevelList()[p].InherentLevels().length; c++) {
                                $('#InherentDDYX_' + RlViewModel.InherentMasterMatrixRiskLevelList()[p].YAxisLevels()[m].LevelId() + '_' + RlViewModel.InherentMasterMatrixRiskLevelList()[p].XAxisLevels()[k].LevelId()).addClass(RlViewModel.InherentMasterMatrixRiskLevelList()[p].InherentLevels()[c].RiskCSS);
                            }
                        }
                    }
                }
                if (RlViewModel.InherentMasterMatrixRiskLevelList()[p].InherentSectedLevelList().length > 0) {
                    var itemList = RlViewModel.InherentMasterMatrixRiskLevelList()[p].InherentSectedLevelList();
                    for (var f = 0; f < itemList.length; f++) {
                        $('#InherentDDYX_' + itemList[f].YAxisId + '_' + itemList[f].XAxisId).val(itemList[f].InherentAxisId);
                        $('#InherentDDYX_' + itemList[f].YAxisId + '_' + itemList[f].XAxisId).removeClass().addClass('form-control ' + itemList[f].RiskCSS);
                        $('#InherentDDYX_' + itemList[f].YAxisId + '_' + itemList[f].XAxisId).removeAttr('style');
                    }
                }
            }

            $('#InherentCrossMatrix').show();
            $('#InherentCrossMatrixAccordion').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in BindDynamicHtmlForInherentMasterMatrixRatingLevel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlForControlMasterMatrixRatingLevel() {
        try {
            var DynamicHTML = "";
            var controlMatrixName = RlViewModel.ControlMasterMatrixRiskLevelList()[0].ControlMatrixName;
            var controlMatrixId = RlViewModel.ControlMasterMatrixRiskLevelList()[0].ControlMatrixId;

            for (var i = 0; i < RlViewModel.ControlMasterMatrixRiskLevelList().length; i++) {
                var rowf = 1;
                DynamicHTML +=
                    '<div class="d-flex">' +
                    '<div class="col-xs-2 col-sm-2 col-md-2 col-lg-4 no-padding">' +
                    '<label class="control-label">Name: ' + controlMatrixName + '</label> <i class="fa fa-edit mr-1" id="Edit-' + controlMatrixId + '"data-bind="click: $root.CTRLMatrixEditSetupButton"></i></div>' +
                    '<div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">' +
                    '<label id="lblvalidation" class="alert alert-danger " hidden="hidden">' + '</label>' +
                    '</div>' +
                    '<div class="btn-group-sm pull-right ml-auto" data-bind="if: ($root.ControlsAccess())">' +
                    '<button id="Save-' + controlMatrixId + '" class="primary-btn mr-1 mt-1 mb-1" data-bind="click: $root.CTRLMatrixSaveButton">' +
                    '<i class="fa fa-check mr-1"></i>' +
                    'Save' +
                    '</button>' +
                    '<button id="Cancel-' + controlMatrixId + '" class="secondary-btn mr-1 mt-1 mb-1" data-bind="click: $root.CTRLMatrixCancelSetupButton">' +
                    '<i class="fa fa-times mr-1"></i>' +
                    ' Cancel' +
                    '</button>' +
                    '<button id="Delete-' + controlMatrixId + '" class="secondary-btn mr-1 mt-1 mb-1" data-bind="click: $root.CTRLMatrixDeleteSetupButton" >' +
                    '<i class="fa fa-trash-o mr-1"></i>' +
                    ' Delete Scale' +
                    '</button>' +
                    '<label class="field-validation-error" style="display:none" id="lblOverallValidation">' + '*required' + '</label>' +
                    '</div>' +
                    '</div>';

                var XAxisLevels = RlViewModel.ControlMasterMatrixRiskLevelList()[i].XAxisLevels();
                var YAxisLevels = RlViewModel.ControlMasterMatrixRiskLevelList()[i].YAxisLevels();

                var XAxisName = "";
                XAxisName = "" + RlViewModel.ControlMasterMatrixRiskLevelList()[i].XAxisName + " ( " + RlViewModel.ControlMasterMatrixRiskLevelList()[i].XPercentage + "% )";

                var YAxisName = "";
                YAxisName = RlViewModel.ControlMasterMatrixRiskLevelList()[i].YAxisName + " ( " + RlViewModel.ControlMasterMatrixRiskLevelList()[i].YPercentage + "% )";

                var AxisName = XAxisName + ' / ' + YAxisName;

                DynamicHTML +=
                    '<div id="CTRLMapping" class="overflow-auto">' +
                    '<table style="width:100% !important" id="tblCTRL' + controlMatrixId + '" class="table table-condensed risklevel_tables no-padding no-padding-right">' +
                    '<thead>' +
                    '<tr>' +
                    '<th class="bg-white borderclass"></th><th class="bg-white borderclass"></th><th class ="text-center ResidualHeaders matrxHeader" data-bind ="attr:{colspan :' + (XAxisLevels.length) + '}">' + XAxisName + '</th>'


                DynamicHTML += '</tr>' + '</thead>' + '<tbody><tr><td class="bg-white borderclass"></td><td class="bg-white borderclass"></td>';

                for (var j = 0; j < XAxisLevels.length; j++) {
                    DynamicHTML += '<td class="text-center ResidualHeadersRows residual-text-alignment" id="1">' + XAxisLevels[j].LevelName() + '</td>';
                }
                DynamicHTML += '</tr >';
                for (var k = 0; k < YAxisLevels.length; k++) {
                    DynamicHTML +=
                        '<tr>';
                    if (rowf == 1) {
                        DynamicHTML += '<td class="matrxHeader" data-bind ="attr:{rowspan :' + (YAxisLevels.length) + '}">' + YAxisName + '</td>';
                        rowf++;
                    }

                    DynamicHTML += '<td id="' + YAxisLevels[k].LevelId() + '" class="text-center residual-text-alignment ResidualHeadersRows">' + YAxisLevels[k].LevelName() + '</td>';
                    for (var f = 0; f < XAxisLevels.length; f++) {
                        DynamicHTML +=
                            '<td class="text-center" >' +
                            '<select id="ControlDDYX_' + YAxisLevels[k].LevelId() + '_' + XAxisLevels[f].LevelId() + '" class="form-control1 dark-grey" data-bind="options: $root.ControlMasterMatrixRiskLevelList()[' + i + '].ControlLevels(), optionsText : \'LevelName\', optionsValue: \'LevelId\',optionsAfterRender: $root.SetRESOptionsClass, css: \'RiskCSS\', value: \'RiskCSS\', event: {change: $root.ActionChangedCSS}">' + '</select>' +
                            '</td>';
                    }
                    DynamicHTML += '</tr>';
                }

                DynamicHTML += '</tbody>' + '</table>' + '</div>' ;

            }
            document.getElementById("ControlCrossMatrix").innerHTML = "";
            document.getElementById("ControlCrossMatrix").innerHTML = DynamicHTML;
            var element = $('#ControlCrossMatrix')[0];
            ko.cleanNode(element);
            ko.applyBindings(RlViewModel, document.getElementById('ControlCrossMatrix'));

            //Map selected residual score to dropdowns if any
            for (var p = 0; p < RlViewModel.ControlMasterMatrixRiskLevelList().length; p++) {
                if (RlViewModel.ControlMasterMatrixRiskLevelList()[p].ControlLevels().length > 0) {
                    for (var m = 0; m < RlViewModel.ControlMasterMatrixRiskLevelList()[p].YAxisLevels().length; m++) {
                        for (var k = 0; k < RlViewModel.ControlMasterMatrixRiskLevelList()[p].XAxisLevels().length; k++) {
                            for (var c = 0; c < RlViewModel.ControlMasterMatrixRiskLevelList()[p].ControlLevels().length; c++) {
                                $('#ControlDDYX_' + RlViewModel.ControlMasterMatrixRiskLevelList()[p].YAxisLevels()[m].LevelId() + '_' + RlViewModel.ControlMasterMatrixRiskLevelList()[p].XAxisLevels()[k].LevelId()).addClass(RlViewModel.ControlMasterMatrixRiskLevelList()[p].ControlLevels()[c].RiskCSS);
                            }
                        }
                    }
                }
                if (RlViewModel.ControlMasterMatrixRiskLevelList()[p].ControlSectedLevelList().length > 0) {
                    var itemList = RlViewModel.ControlMasterMatrixRiskLevelList()[p].ControlSectedLevelList();
                    for (var f = 0; f < itemList.length; f++) {
                        $('#ControlDDYX_' + itemList[f].YAxisId + '_' + itemList[f].XAxisId).val(itemList[f].ControlAxisId);
                        $('#ControlDDYX_' + itemList[f].YAxisId + '_' + itemList[f].XAxisId).removeClass().addClass('form-control ' + itemList[f].RiskCSS);
                        $('#ControlDDYX_' + itemList[f].YAxisId + '_' + itemList[f].XAxisId).removeAttr('style');
                    }
                }
            }

            $('#ControlCrossMatrix').show();
            $('#ControlCrossMatrixAccordion').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in BindDynamicHtmlForControlMasterMatrixRatingLevel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtmlforControls() {
        try {
            var DynamiControlHtml = "";
            for (var i = 0; i < RlViewModel.ControlsRiskLevelList().length; i++) {
                DynamiControlHtml += '<div class="d-flex">' +
                    '<div class="col-xs-2 col-sm-2 col-md-2 col-lg-4 no-padding">' +
                    '<label class="control-label">' +
                    'Name: ' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelName +
                    '</label> <i class="fa fa-edit mr-1" id="controledit' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '" data-bind="click: $root.CRSEditButton"></i></div>' +
                    '<div class="btn-group-sm pull-right ml-auto" data-bind="if: ($root.ControlsAccess())">';

                if (RlViewModel.ControlsRiskLevelList()[i].Type == 'Final') {
                    DynamiControlHtml += '    <button id="controlAddMatrix' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '" data-bind="click: $root.CRSAddMatrixButton" class="primary-btn" type="submit">' +
                        '     <i class="fa fa-plus mr-1"></i>' +
                        ' Add Matrix' +
                        ' </button>';

                }
                DynamiControlHtml += '    <button id="controlAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '" data-bind="click: $root.CRSAddButton" class="primary-btn" type="submit">' +
                    '     <i class="fa fa-plus mr-1"></i>' +
                    ' Add' +
                    ' </button>' +
                    ' <button id="controlsave' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '" data-bind="click: $root.CRSSaveButton" class="primary-btn" type="submit">' +
                    '<i class="fa fa-check mr-1"></i>' +
                    ' Save' +
                    ' </button>' +
                    ' <button id="controlcancel' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '" data-bind="click: $root.CRSCancelButton" class="secondary-btn" type="submit">' +
                    ' <i class="fa fa-times mr-1"></i>' +
                    'Cancel' +
                    '</button>' +
                    ' <button id="controldelete' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '" data-bind="click: $root.CRSDeleteSetupButton" class="secondary-btn" type="submit">' +
                    ' <i class="fa fa-trash-o mr-1"></i>' +
                    ' Delete Scale' +
                    '</button>' +


                    '</div>' +
                    ' </div>';

                var id = 'ControlsRiskLevelList()[' + i + '].MappedRiskLevels';
                DynamiControlHtml += '<div class="row-fluid">' +
                    '<label class="alert alert-danger col-xs-12 col-sm-12 col-md-12 col-lg-12" style="display:none" id="lblCommonValidation' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '">*required</label>' +
                    '<label class="field-validation-error" style="display:none" id="lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '">*required</label>' +
                    '<table id="tblCRS" class="table table-bordered border-0 no-footer dataTable" cellspacing="0">' +
                    ' <thead>' +
                    '<tr>';
                if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'P') {
                    DynamiControlHtml += ' <th class="text-center col-width-5">' +
                        '<label>Maximum %</label>' +
                        ' </th>' +
                        '<th class="text-center col-width-5">' +
                        '<label>Minimum %</label>' +
                        '</th>';

                }
                else if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'R') {
                    DynamiControlHtml += ' <th class="text-center col-width-5">' +
                        '<label>Minimum</label>' +
                        ' </th>' +
                        '<th class="text-center col-width-5">' +
                        '<label>Maximum</label>' +
                        '</th>';

                }
                else {
                    DynamiControlHtml += '' +
                        '<th class="text-center col-width-5">' +
                        '<label>Score</label>' +
                        '</th>';

                }


                DynamiControlHtml += 
                    '<th class="text-center width-20-percent">' +
                    '<label>Control Rating Color</label>' +
                    '</th>' +
                    '<th class="text-center width-30">' +
                    '<label>Description</label>' +
                    ' </th>' +
                    '<th class="text-center width-10-percent">' +
                    ' <label>Short Name</label>' +
                    '</th>' +
                    '<th class="text-center width-10-percent">' +
                    ' <label>Rating Adjustment</label>' +
                    '</th>' +
                    '<th class="text-center w-50">' +
                    ' <label>Definition</label>' +
                    '</th>' +
                    '<th class="text-center">' +
                    '<label>Action</label>' +
                    ' </th>' +
                    '</tr>' +
                    '</thead>' +
                    '<tbody data-bind="foreach:' + id + '">' +

                    '<tr>';
                if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'P') {
                    DynamiControlHtml += '<td class="tbl-cell">' +
                        '<div class="input-group">' +
                        '<input class="form-control percentage-input" id="txtControlMax1" data-bind="value: Max, css:{disabled: (!$root.ControlsAccess())}" type="text" disabled ></input>' +
                        '<span class="input-group-addon">%</span>' +
                        '</div>' +




                        ' </td>' +
                        ' <td class="tbl-cell">' +

                        '<div class="input-group">' +
                        '<label id="lblId" data-bind="text: Id" style="display:none"></label>' +
                        '<input class="form-control percentage-input" id="txtControlMin1" data-bind="value: Min, css:{disabled: (!$root.ControlsAccess())},event: {change: $root.MinValueBlur, click: $root.MinValueClick, select: $root.MinValueClick}" type="text"></input>' +
                        '<span class="input-group-addon">%</span>' +

                        '</div>' +
                        '<label class="field-validation-error" style="display:none" id="lblMaxValValidation" data-bind="attr: { id: \'lblMaxValValidation_\' + Id }">*required</label>' +
                        '</td>';

                }
                else if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'R') {
                    DynamiControlHtml += '<td class="tbl-cell">' +
                        '<div class="input-group">' +
                        '<input class="form-control" id="txtControlMin1" data-bind="value: Min, css:{disabled: (!$root.ControlsAccess())}, event: {change: $root.MinCheckDecimal}" type="text"></input>' +
                        '</div>' +
                        ' </td>' +

                        ' <td class="tbl-cell">' +
                        '<div class="input-group">' +
                        '<input class="form-control" id="txtControlMax1" data-bind="value: Max, css:{disabled: (!$root.ControlsAccess())}, event: {change: $root.MaxCheckDecimal}" type="text"></input>' +
                        '</div>' +
                        '<label class="field-validation-error" style="display:none" id="lblMaxValValidation" data-bind="attr: { id: \'lblMaxValValidation_\' + Id }">*required</label>' +

                        '</td>';

                }
                else {
                    DynamiControlHtml +=
                        '<td class="tbl-cell">' +
                        '<div class="input-group">' +
                        '<input class="form-control" id="txtControlMax1" data-bind="value: Max, css:{disabled: (!$root.ControlsAccess())},event: {change: $root.MaxValueBlur}" type="text"  ></input>' +

                        '</div>' +
                        '<label class="field-validation-error" style="display:none" id="lblMaxValValidation" data-bind="attr: { id: \'lblMaxValValidation_\' + Id }">*required</label>' +



                        ' </td>';
                }

                DynamiControlHtml +=                   
                    '<td id="CRSSetupDropDownID" data-bind="css:{disabled: (!$root.ControlsAccess())}">' +
                    '<div class="control-risk-color-wrapper">' +
                    '<span class="risk-color-arrow control-risk-color-arrow risk-color-arrow-down control-risk-color-clickable"></span>' +
                    '<div data-bind="value: CSS, text: CSS, css: CSS" class="control-selected-risk-color control-risk-color-clickable"></div>' +
                    '<div data-bind="foreach: $root.QualitativeRiskLevelList" class="control-risk-color-dropdown-wrapper risk-color-hide">' +
                    '<div data-bind="text: RiskLevelCSS, css: RiskLevelCSS, value: RiskLevelCSS, click: $root.SetControlRiskColorValue" class="control-risk-color-selectable"></div>' +
                    '</div>' +
                    '</div>' +
                    '</td>' +

                    '<td>' +
                    '<textarea id="txtControlDescription1" class="form-control" data-bind="value: Description, css:{disabled: (!$root.ControlsAccess())}" placeholder="Please enter a Description" rows="2" cols="30"></textarea>' +
                    '<label class="field-validation-error" id="lblDescValidation" style="display:none" data-bind="attr: { id: \'lblDescValidation_\' + Id }">*required</label>' +
                    '</td>' +
                    '<td>' +
                    '<textarea class="form-control" id="txtShortName" name="Short Name" data-bind="value: RiskLevelShortName, css:{disabled: (!$root.ControlsAccess())}"></textarea>' +
                    ' </td>' +
                    '<td>' +
                    '<textarea class="form-control" id="txtRatingAdj" name="Rating Adjustment" data-bind="value: RiskLevelAdj, css:{disabled: (!$root.ControlsAccess())}"></textarea>' +
                    ' </td>' +

                    '<td>' +
                    '<textarea id="txtControlComment1" class="form-control" data-bind="value: Comments, css:{disabled: (!$root.ControlsAccess())}" placeholder="Please enter a Comment" rows="2" cols="80"></textarea>' +
                    '</td>' +

                    '<td class="text-center">' +
                    '<a id="' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + '" href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.CRSSetupDeleteButton, css:{disabled: (!$root.ControlsAccess())}">' +
                    '<div data-bind="if:Id">' +
                    '<i class="demo-icon icon-bin_special"></i>' +
                    '</div>' +
                    '</a>' +
                    '</td>' +

                    '</tr>' +
                    '</tbody>' +
                    '</table>' +
                    '</div>' +

                    '</div>';
            }
            document.getElementById('tabsControl').innerHTML = "";
            document.getElementById('tabsControl').innerHTML = DynamiControlHtml;
            var element = $('#tabsControl')[0];
            ko.cleanNode(element);
            ko.applyBindings(RlViewModel, document.getElementById('tabsControl'));
            $('#tabsControl').show();
            $("#tabsControl").removeClass('ui-widget-content');

            for (var i = 0; i < RlViewModel.ControlsRiskLevelList().length; i++) {
                if (RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels().length == 0) {
                    $("#lblCommonValidation" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();

                    document.getElementById("lblCommonValidation" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Control Rating is not configured yet."
                }
                else {
                    $("#lblCommonValidation" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).hide();
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajaxFail in BindDynamicHtmlforControls() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function BindDynamicHtml() {
        try {
            var DynamicHtml = "";
            var AddMatrixHTML = "";
            for (var i = 0; i < RlViewModel.InherentRiskLevelList().length; i++) {

                AddMatrixHTML = "";

                if (RlViewModel.InherentRiskLevelList()[i].ScoringType == "Final") {


                    AddMatrixHTML = '<button id="AddMatrix" class="primary-btn mr-1" data-bind="click: IRSAddMatrixButton" type="submit"><i class="fa fa-plus mr-1"></i> Add Matrix</button>';

                }

                DynamicHtml += ' <div class="d-flex">' +
                    ' <div class="col-xs-1 col-sm-1 col-md-5 col-lg-98 no-padding"><label class="control-label"> Name: ' + RlViewModel.InherentRiskLevelList()[i].RiskLevelName + '</label>  <i class="fa fa-edit mr-1" name = "Edit"  id = "' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId + '"data-bind="click: IRSEditButton"></i ></div>' +
                    '<div class="pull-right ml-auto" data-bind="if: ($root.ControlsAccess())">' +
                    AddMatrixHTML +

                    '<button id="Add' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId + '" data-bind="click: $root.InhAddButton" class="primary-btn" type="submit">' +
                    '     <i class="fa fa-plus mr-1"></i>' +
                    ' Add' +
                    ' </button>' +
                    ' <button id="save-' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId + '" name="L" class="primary-btn" data-bind="click: IRSSaveButton" type="submit">' +
                    '    <i class="fa fa-check mr-1"></i>' +
                    '   Save' +
                    '</button>' +
                    '  <button name="L"  id="cancel-' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId + '" class="secondary-btn" data-bind="click: IRSCancelButton" type="submit">' +
                    ' <i class="fa fa-times mr-1"></i>' +
                    '   Cancel' +
                    '  </button>' +
                    '<button id="Delete-Scale-' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId + '" class="secondary-btn ml-1" data-bind="click: $root.IRSDeleteSetupButton"  type="submit">' +
                    '<i class=" fa fa-trash-o mr-1">' + '</i>' + ' Delete Scale' +
                    '</button>' +
                    ' </div>' +

                    '</div>';
                DynamicHtml += '<label id="lblError' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId + '" class="field-validation-error" style="display:none"></label>'

                DynamicHtml += '<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding no-padding-right">' +
                    '<table id="tblIRSQuant" class="table table-bordered border-0 no-footer dataTable" cellspacing="0">' +
                    '<thead>' +
                    '<tr>' +
                    '<th style="width: 7%;" class="text-center">' +
                    '<label>Risk Score</label>' +
                    '</th>' +
                    '<th style="width: 27%;" class="text-center">' +
                    '<label>' + RlViewModel.InherentRiskLevelList()[i].RiskLevelName + '</label>' +
                    '</th>' +
                    '<th style="width: 7%;" class="text-center">' +
                    ' <label>Short Name</label>' +
                    '</th>' +
                    '<th style="width: 10%;" class="text-center">' +
                    ' <label>Color</label>' +
                    '</th>' +
                    '<th style="width: 10%;" class="text-center">' +
                    ' <label>Rating Adjustment</label>' +
                    '</th>' +
                    ' <th style="width: 53%;" class="text-center">' +
                    ' <label>Definition</label>' +
                    ' </th>' +
                    
                    '<th class="text-center">' +
                    '<label>Action</label>' +
                    ' </th>' +

                    ' </tr>' +

                    '  </thead>';

                var DynamicListName = "InherentRiskLevelList()[" + i + "].MappedRiskLevels";
                DynamicHtml += ' <tbody data-bind="foreach: ' + DynamicListName + '">' +

                    ' <tr>' +
                    ' <td class="text-center">' +

                    '<label id="lblId" data-bind="text: RiskLevel"  style="display:none"></label>' +
                    '<input class="form-control" id="lblLevel" name="Risk Levels" data-bind="value: RiskLevel, css:{disabled: (!$root.ControlsAccess())}"></input>' +

                    ' </td>' +
                    ' <td>' +
                    '<textarea class="form-control" id="txtDescription" name="Risk Levels" data-bind="value: RiskLevelDescription, css:{disabled: (!$root.ControlsAccess())}"></textarea>' +
                    ' <label class="field-validation-error" style="display:none" id="lblValidation">*required</label>' +

                    ' </td>' +

                    ' <td>' +
                    '<textarea class="form-control" id="txtShortName" name="Short Name" data-bind="value: RiskLevelShortName, css:{disabled: (!$root.ControlsAccess())}"></textarea>' +
                    ' </td>' +


                    ' <td style="width: 16%">' +

                    '<div class="risk-color-wrapper">' +
                    '<span class="risk-color-arrow inherent-risk-color-arrow risk-color-arrow-down risk-color-clickable"></span>' +
                    '<div data-bind="value: CSS, text: CSS || \'Pick a color\', css: CSS" class="selected-risk-color risk-color-clickable"></div>' +


                    '<div data-bind="foreach: $root.QualitativeRiskLevelList" class="risk-color-dropdown-wrapper risk-color-hide">' +
                    '<div data-bind="text: RiskLevelCSS, css: RiskLevelCSS, click: $root.SetRiskColorValue" class="risk-color-selectable"></div>' +
                    '</div>' +
                    '</div>' +
                    '</td>' +

                    ' <td>' +
                    '<textarea class="form-control" id="txtRatingAdj" name="Rating Adjustment" data-bind="value: RiskLevelAdj, css:{disabled: (!$root.ControlsAccess())}"></textarea>' +
                    ' </td>' +

                    '<td>' +
                    '<textarea class="form-control" id="txtDescription" name="Risk Levels" data-bind="value:RiskLevelComents,css:{disabled: (!$root.ControlsAccess())}"></textarea>' +
                    '</td>' +
                    
                    '<td class="text-center">' +
                    '<a id="' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId + '" href="javascript:void(0)" title="Delete" class="btn-borderless widget-button" data-bind="click: $root.InhSetupDeleteButton, css:{disabled: (!$root.ControlsAccess())}">' +

                    '<div data-bind="if:RiskLevelId">' +
                    '<i class="demo-icon icon-bin_special"></i>' +
                    '</div>' +


                    '</a>' +
                    '</td>' +
                    '</tr>' +
                    ' </tbody>' +
                    '</table>' +
                    '</div>';

            }

            if (RlViewModel.IsRowDelete() == false) {
                for (var i = 0; i < RlViewModel.InherentRiskLevelList().length; i++) {
                    if ((RlViewModel.InherentRiskLevelList()[i].LevelCount - RlViewModel.InherentRiskLevelList()[i].MappedRiskLevels.length) > 0) {
                        var count = (RlViewModel.InherentRiskLevelList()[i].LevelCount - RlViewModel.InherentRiskLevelList()[i].MappedRiskLevels.length);
                        for (var j = 0; j < count; j++) {
                            var newmappedObject = new InherentRiskLevelModel({ RiskLevelcss: "", RiskLevelComents: "", RiskLevelDescription: "", RiskLevel: RlViewModel.InherentRiskLevelList()[i].MappedRiskLevels.length + 1 })
                            RlViewModel.InherentRiskLevelList()[i].MappedRiskLevels.push(newmappedObject);
                        }
                    }
                }

            }
            document.getElementById('tabsInherent').innerHTML = "";
            document.getElementById('tabsInherent').innerHTML = DynamicHtml;
            var element = $('#tabsInherent')[0];
            ko.cleanNode(element);
            ko.applyBindings(RlViewModel, document.getElementById('tabsInherent'));
            $("#RiskSetup").removeClass('ui-widget-content');
            $('#tabsInherent').show();


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtml() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function IRSEditButton(data, event) {
        try {
            RlViewModel.IsEditRiskLevel(true);
            var id = event.currentTarget.id;
            for (var i = 0; i < (RlViewModel.InherentRiskLevelList().length); i++) {
                if (RlViewModel.InherentRiskLevelList()[i].RiskLevelId == parseInt(id)) {
                    var MappededitabelModel = new RiskLevelModel({
                        RiskLevelId: RlViewModel.InherentRiskLevelList()[i].RiskLevelId, RiskLevelName: RlViewModel.InherentRiskLevelList()[i].RiskLevelName,
                        RiskLevelShortText: RlViewModel.InherentRiskLevelList()[i].RiskLevelShortName, ScoringType: RlViewModel.InherentRiskLevelList()[i].ScoringType,
                        RiskLevelCount: RlViewModel.InherentRiskLevelList()[i].LevelCount, isQuantitative: RlViewModel.InherentRiskLevelList()[i].isQuantitative,
                        ApplicableZATIds: RlViewModel.InherentRiskLevelList()[i].ApplicableZATIds, ApplicableZATNames: RlViewModel.InherentRiskLevelList()[i].ApplicableZATNames
                    });
                    RlViewModel.editaleRiskLevel();
                    RlViewModel.editaleRiskLevel(MappededitabelModel);
                    RlViewModel.popUpTitle("Edit Risk Scale");
                    RlViewModel.addPopUpCss(false);
                    $('#frmInhRiskLevel').modal("show")
                    $('#frmSubFactor').modal('show');

                    $('#isControlScaleFinal').hide();
                    $('#SelectTypeOfScaleDropdown').hide();
                    $('#NoOfLevelsDropdown').hide();
                    $("#RAApplicability").prop("disabled", true);
                    if (RlViewModel.InherentRiskLevelList()[i].ScoringType == "Final") {
                        $("#isQuantitativeScale").hide();
                    }
                    $('#AddZAT').hide();
                    $('#EditZAT').show();
                    $('#ZATNamesForEdit').empty();
                    var ZATNames = "";
                    if (MappededitabelModel.ApplicableZATNames === null)
                        ZATNames = "NA";
                    else
                        ZATNames = MappededitabelModel.ApplicableZATNames;
                    document.getElementById('ZATNamesForEdit').innerHTML = ZATNames;
                    document.getElementById('ZATNamesForEdit').title = ZATNames;

                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IRSEditButton() method in GetAllInherentLevels.js';
            logger.logMessage(msg);
        }
    }

    function IRSCreateButton(data, event) {
        try {
            RlViewModel.IsRowDelete(false);
            RlViewModel.IsEditRiskLevel(false);
            RlViewModel.editaleRiskLevel();
            RlViewModel.SelectedSurveyCategoriesList([]);
            var MappedModel = new RiskLevelModel({
                RiskLevelId: null, RiskLevelName: "", RiskLevelShortText: "", ScoringType: "", isFinal: false, RiskLevelCount: "", ScaleType: "", CRTDId: RlViewModel.SelectedControlsResponseType()
            });
            $('#EditZAT').hide();
            RlViewModel.editaleRiskLevel(MappedModel);
            $('#frmInhRiskLevel').modal("show");
            $('#frmSubFactor').modal('show');

            $('#isControlScaleFinal').removeClass('d-flex').hide();
            $('#SelectTypeOfScaleDropdown').hide();
            $('#NoOfLevelsDropdown').show();
            RlViewModel.addPopUpCss(true);
            $("#RAApplicability").prop("disabled", false);
            if (RlViewModel.ClickType() == "CTRL") {
                $('#UsedToHideMultiselectDropDown').show();
                $('#CRTDMultiSelect').multiselect();
                RlViewModel.addPopUpCtrlCss(true);
                $('#isControlScaleFinal').show();
                $('#SelectTypeOfScaleDropdown').show();
                $('#RaApplicabilityDropdown').removeClass('d-flex').hide();
                $('#NoOfLevelsDropdown').removeClass('d-flex').hide();
                $('#isQuantitativeScale').removeClass('d-flex').hide();
                RlViewModel.popUpTitle("Add New Rating Scale");
            }
            else if (RlViewModel.ClickType() == 'RES') {
                $('#isControlScaleFinal').removeClass('d-flex').hide();
                $('#SelectTypeOfScaleDropdown').hide();
                $('#RaApplicabilityDropdown').removeClass('d-flex').hide();
                $('#NoOfLevelsDropdown').removeClass('d-flex').hide();
                $('#isQuantitativeScale').removeClass('d-flex').hide();
                $("#AddZATMultiSelect").multiselect();

                $('#AddZATMultiSelect').multiselect('refresh');
                RlViewModel.popUpTitle("Add New Risk Scale");
            }
            else {
                $('#AddZAT').show();

                $('#AddZATMultiSelect').show();
                $("#AddZATMultiSelect").multiselect();

                $('#AddZATMultiSelect').multiselect('refresh');
                RlViewModel.popUpTitle("Add New Risk Scale");
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IRSCreateButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetControlResponseTypeDetails() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetControlResponseTypeDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { ScreenType: 'RS' }
            })
                .success(function (jsonResult, error) {
                    RlViewModel.ControlResponseTypeList([]);
                    if (jsonResult != null) {
                        if (jsonResult.length != 0) {
                            var MappedResponseLevels = $.map(jsonResult, function (result) {
                                return new ResponseDataModel(result);
                            });
                            RlViewModel.ControlResponseTypeList([]);
                            RlViewModel.ControlResponseTypeList(MappedResponseLevels);
                        }
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError('An error has occurred while fetching the Control Response Type Details. Please contact your Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetControlResponseTypeDetails() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }


    //cross matrix inherent create button logic
    function IRSAddMatrixButton(data, event) {
        try {
            RlViewModel.MatrixAxisList();
            RlViewModel.InherentScaleList();
            //populate three dropdowns
            GetMasterLevelsInherent();
            RlViewModel.InherentScale();
            var MappedModel = new InherentCrossMatrixModel({ InherentMatrixId: null, InherentMatrixName: "", XAxisId: "", YAxisId: "", InherentAxisId: "" })
            RlViewModel.InherentScale(MappedModel);
            RlViewModel.popUpTitle("Add Inherent Risk Matrix");
            $('#frmInherentMatrix').modal("show");

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IRSAddMatrixButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function CRSAddMatrixButton(data, event) {
        try {
            RlViewModel.MatrixAxisList();
            RlViewModel.ControlScaleList();
            //populate three dropdowns
            GetMasterLevelsControl();
            RlViewModel.ControlScale();
            var MappedModel = new ControlCrossMatrixModel({ ControlMatrixId: null, ControlMatrixName: "", XAxisId: "", YAxisId: "", ControlAxisId: "", XPercentage: 50, YPercentage: 50 })
            RlViewModel.ControlScale(MappedModel);
            RlViewModel.popUpTitle("Add Control Matrix");
            $('#frmControlMatrix').modal("show");

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSAddMatrixButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    //cross matrix residual create button logic
    function CMRCreateButton(data, event) {
        try {
            RlViewModel.MatrixAxisList();
            RlViewModel.ResidualScaleList();
            //populate three dropdowns
            GetMasterLevels();

            RlViewModel.residualScale();
            var MappedModel = new ResidualCrossMatrixModel({ ResidualMatrixId: null, ResidualMatrixName: "", XAxisId: "", YAxisId: "", ResidualAxisId: "" })
            RlViewModel.residualScale(MappedModel);
            RlViewModel.popUpTitle("Add Residual Risk Matrix");
            $('#frmResidualMatrix').modal("show")

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CMRCreateButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function RiskLevelTabClick(data, event) {
        try {
            $('#lblCommonValidation').hide();
            $('#lblRRSCommonValidation').hide();
            RlViewModel.ReadyToClick(false);
            ko.bindingHandlers['uniqueName'].currentIndex = 0;
            RlViewModel.ImagePathList([]);
            document.getElementById('tabsInherent').innerHTML = "";
            document.getElementById('tabsControl').innerHTML = "";
            document.getElementById('tabsResidual').innerHTML = "";
            TabLogicSegregator(event.currentTarget.id);
            RlViewModel.ClickType(event.currentTarget.id);
            $('#RiskLevelUL li').removeClass('active');
            $('#' + event.currentTarget.id).addClass('active');
            event.stopImmediatePropagation();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelTabClick() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function TabLogicSegregator(TabName) {
        try {
            $('#tabsInherent').hide();
            $('#tabsInherentRiskLevel').hide();
            $('#tabsControl').hide();
            $('#tabsResidual').hide();
            $('#tabsResidualSetup').hide();
            $('#residualAccordion').hide();
            RlViewModel.AddInherentMatrix(false);
            RlViewModel.AddResidualMatrix(false);
            $('#Residualaccordion').hide();
            $('#residualCrossMatrix').hide();
            $('#residualCrossMatrixAccordion').hide();
            $('#InherentCrossMatrix').hide();
            $('#InherentCrossMatrixAccordion').hide();
            $('#ControlCrossMatrixAccordion').hide();
            $('#ControlCrossMatrix').hide();
            if (TabName == "INH") {
                var pageType = "I"
                GetAllQualitativeRiskLevel(pageType).then(function () {
                    GetAllInherentLevels();
                    RlViewModel.ReadyToClick(true);
                    $('#tabsInherent').show();
                    $('#tabsControl').hide();
                    $('#tabsResidual').hide();
                    $('NoDataErrorControls').hide();
                    $('#tabsResidualSetup').hide();
                    $('#residualAccordion').hide();
                    RlViewModel.AddResidualMatrix(false);
                    $('#residualCrossMatrix').hide();
                    $('#Residualaccordion').hide();
                    $('#residualCrossMatrixAccordion').hide();
                })
            }
            else if (TabName == "CTRL") {
                CRSStart();
                GetAllControlsLevels();
                GetControlResponseTypeDetails();
                $('#tabsInherent').hide();
                $('#tabsInherentRiskLevel').hide();
                $('InherentCrossMatrix').hide();
                $('InherentCrossMatrixAccordion').hide();
                $('#tabsResidual').hide();
                $('#tabsResidualSetup').hide();
                $('#residualAccordion').hide();
                RlViewModel.AddResidualMatrix(false);
                $('#residualCrossMatrix').hide();
                $('#Residualaccordion').hide();
                $('#residualCrossMatrixAccordion').hide();
            }
            else if (TabName == "RES") {
                var PageType = "R"
                $('InherentCrossMatrix').hide();
                $('InherentCrossMatrixAccordion').hide();
                $('#tabsInherent').hide();
                $('#tabsInherentRiskLevel').hide();
                $('#tabsControl').hide();
                $('NoDataErrorControls').hide();
                $('#Residualaccordion').show();
                GetAllQualitativeRiskLevel(PageType).then(function () {
                    GetStandardApplicationLevels().then(function () {
                        GetCRSColorpalette("R").then(function () {
                            GetAllResidualLevels().then(function () {
                                RRSStart();
                            })
                        });

                    })

                })


            }
            else if (TabName == "Qualitative Data Risk Setup - AML" || TabName == "Qualitative Data Risk Setup - Sanctions") {
                $('#loadingMainImgDiv').hide();
                QRSStart(TabName);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: TabLogicSegregator() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------Logic for Inherent Risk Level Starts here----------------------------------------------------------------------------------------------
    function GetAllQualitativeRiskLevel(PageType) {
        try {
            return $.ajax({
                url: "/api/Configuration/GetHeatMapColors",
                data: { "PageType": PageType },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail)
        } catch (e) {
            var msg = 'Exception' + e + ' | source : ajaxCall in GetQualitativeData() in OtherQualitativeRiskAssessment.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                var mappedFinalRiskLevel = $.map(jsonResult, function (result) {
                    if (result.RiskLevel != 'NA') {
                        return new GetAllQualitativeRiskLevelModel(result);
                    }
                })
                RlViewModel.QualitativeRiskLevelList(mappedFinalRiskLevel);

                for (var i = 0; i < RlViewModel.QualitativeRiskLevelList().length; i++) {

                    RlViewModel.ImagePathList().push(RlViewModel.QualitativeRiskLevelList()[i].imagePath());
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetFinalRiskLevelDetails() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetFinalRiskLevelDetailsQualitative() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetFinalRiskLevelDetailsQualitative() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

    }

    function GetAllQualitativeRiskLevelModel(item) {
        try {
            var self = this;
            if ($('<div/>').html(item.RiskLevel).text() != 'NA') {
                self.RiskLevelCSS = ko.observable($('<div/>').html(item.RiskLevelCss).text());
                self.CSSName = ko.observable($('<div/>').html(item.CssName).text());
                var ImagePath = self.RiskLevelCSS() + '.png';
                var CompletePath = '../../../Content/images/';
                self.imagePath = ko.observable((CompletePath).concat(ImagePath));
            }
        } catch (e) {

            var msg = 'Exception: ' + e + ' | Source:GetAllQualitativeRiskLevelModel () method in AMLInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function saveResidualRiskMatrixPopup(data, event) {
        try {
            $('#valErrorRS').hide();
            if (data.ResidualMatrixName == "") {
                $('#valErrorRS').show();
                $('#valErrorRS').text('Residual Risk Matrix Name is required.');
                return false;
            }
            if (RlViewModel.MasterMatrixRiskLevelList().length > 0) {
                $('#valErrorRS').show();
                $('#valErrorRS').text('Multiple Residual Risk Matrix cannot be added.');
                return false;
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveRiskMatrix",
                type: "POST",
                headers: headers,
                data: { ResidualMatrixName: data.ResidualMatrixName, ResidualAxisId: data.ResidualAxisId, XAxisId: data.XAxisId, YAxisId: data.YAxisId, AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == "-99") {
                        logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                    } else if (JsonResult == "0" || JsonResult == null) {
                        $('#NoDataErrorMatrix').show();
                        document.getElementById('residualCrossMatrix').innerHTML = "";
                    } else if (isNaN(JsonResult) && JsonResult.substring(0,3) == "INC") {
                        logger.logError(JsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        $('#NoDataErrorResidual').hide();
                        $('#frmResidualMatrix').modal("hide");
                        GetAllRiskLevelMatrix();
                        logger.logSuccess('Details saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                    }

                })
                .fail(function (JsonResult, status) {
                    $('#frmResidualMatrix').modal("hide");
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: GetMasterLevels() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in GetMasterLevels() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function saveInherentRiskMatrixPopup(data, event) {
        try {
            $('#valErrorRS').hide();
            if (data.InherentMatrixName == "") {
                $('#valErrorRS').show();
                $('#valErrorRS').text('Inherent Risk Matrix Name is required.');
                return false;
            }
            if (RlViewModel.InherentMasterMatrixRiskLevelList().length > 0) {
                $('#valErrorRS').show();
                $('#valErrorRS').text('Multiple Inherent Risk Matrix cannot be added.');
                return false;
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveInherentRiskMatrix",
                type: "POST",
                headers: headers,
                data: { InherentMatrixName: data.InherentMatrixName, InherentAxisId: data.InherentAxisId, XAxisId: data.XAxisId, YAxisId: data.YAxisId, AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == "-99") {
                        logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                    } else if (JsonResult == "0" || JsonResult == null) {
                        $('#NoDataErrorMatrix').show();
                        document.getElementById('InherentCrossMatrix').innerHTML = "";
                    } else if (isNaN(JsonResult) && JsonResult.substring(0, 3) == "INC") {
                        logger.logError(JsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    } 
                    else {
                        $('#NoDataErrorResidual').hide();
                        $('#frmInherentMatrix').modal("hide");
                        GetAllRiskLevelInherentMatrix();
                        logger.logSuccess('Details saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                    }

                })
                .fail(function (JsonResult, status) {
                    $('#frmInherentMatrix').modal("hide");
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: saveInherentRiskMatrixPopup() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in saveInherentRiskMatrixPopup() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function saveControlMatrixPopup(data, event) {
        try {
            $('#valErrorCS').hide();
            if (data.ControlMatrixName == "") {
                $('#valErrorCS').show();
                $('#valErrorCS').text('Control Matrix Name is required.');
                return false;
            }
            if (RlViewModel.ControlMasterMatrixRiskLevelList().length >= 1) {
                $('#valErrorCS').show();
                $('#valErrorCS').text('Only 1 Control Matrix can be added.');
                return false;
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveControlRiskMatrix",
                type: "POST",
                headers: headers,
                data: { ControlMatrixName: data.ControlMatrixName, ControlAxisId: data.ControlAxisId, XAxisId: data.XAxisId, YAxisId: data.YAxisId, AssessmentId: RlViewModel.ClickedAssessmentTypeId(), XPercentage: data.XPercentage, YPercentage: data.YPercentage }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == "-99") {
                        logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                    } else if (JsonResult == "0" || JsonResult == null) {
                        logger.logError('An error occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    } else if (isNaN(JsonResult) && JsonResult.substring(0, 3) == "INC") {
                        logger.logError(JsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        $('#frmControlMatrix').modal("hide");
                        GetAllRiskLevelControlMatrix();
                        logger.logSuccess('Details saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                    }

                })
                .fail(function (JsonResult, status) {
                    $('#frmControlMatrix').modal("hide");
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: saveControlMatrixPopup() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in saveControlMatrixPopup() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function EditInherentRiskMatrixPopup(data, event) {
        try {
            $('#valErrorRS').hide();
            if (data.InherentMatrixName == "") {
                $('#valErrorRS').show();
                $('#valErrorRS').text('Risk Matrix Name is required.');
                return false;
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/EditInherentRiskMatrix",
                type: "POST",
                headers: headers,
                data: { InherentMatrixName: data.InherentMatrixName, InherentMatrixId: data.InherentMatrixId }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == "-99") {
                        logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                    } else if (JsonResult == "0" || JsonResult == null) {
                        logger.logError('Some error occured while updating the Matrix.', 'Error', system.getModuleId(RlViewModel), true);
                    } else if (isNaN(JsonResult) && JsonResult.substring(0, 3) == "INC") {
                        logger.logError(JsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        $('#frmInherentMatrixEdit').modal("hide");

                        GetAllRiskLevelInherentMatrix();
                        logger.logSuccess('Details saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                    }

                })
                .fail(function (JsonResult, status) {
                    $('#frmInherentMatrixEdit').modal("hide");
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: EditInherentRiskMatrixPopup() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in EditInherentRiskMatrixPopup() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function EditControlRiskMatrixPopup(data, event) {
        try {
            $('#valErrorCS').hide();
            if (data.ControlMatrixName == "") {
                $('#valErrorCS').show();
                $('#valErrorCS').text('Risk Matrix Name is required.');
                return false;
            }


            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/EditControlRiskMatrix",
                type: "POST",
                headers: headers,
                data: { ControlMatrixName: data.ControlMatrixName, ControlMatrixId: data.ControlMatrixId, XPercentage: data.XPercentage, YPercentage: data.YPercentage }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == "0" || JsonResult == null) {
                        logger.logError('Some error occured while updating the Matrix.', 'Error', system.getModuleId(RlViewModel), true);
                    } else if (isNaN(JsonResult) && JsonResult.substring(0, 3) == "INC") {
                        logger.logError(JsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        $('#frmControlMatrixEdit').modal("hide");

                        GetAllRiskLevelControlMatrix();
                        logger.logSuccess('Details saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                    }

                })
                .fail(function (JsonResult, status) {
                    $('#frmControlMatrixEdit').modal("hide");
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: EditControlRiskMatrixPopup() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in EditControlRiskMatrixPopup() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function EditResidualRiskMatrixPopup(data, event) {
        try {
            $('#valErrorRS').hide();
            if (data.ResidualMatrixName == "") {
                $('#valErrorRS').show();
                $('#valErrorRS').text('Risk Matrix Name is required.');
                return false;
            }

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/EditResidualRiskMatrix",
                type: "POST",
                headers: headers,
                data: { ResidualMatrixName: data.ResidualMatrixName, ResidualMatrixId: data.ResidualMatrixId }
            })
                .success(function (JsonResult, status) {
                    if (JsonResult == "0" || JsonResult == null) {
                        logger.logError('Some error occured while updating the Matrix.', 'Error', system.getModuleId(RlViewModel), true);
                    } else if (isNaN(JsonResult) && JsonResult.substring(0, 3) == "INC") {
                        logger.logError(JsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        $('#frmResidualMatrixEdit').modal("hide");

                        GetAllRiskLevelMatrix();

                        logger.logSuccess('Details saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                    }

                })
                .fail(function (JsonResult, status) {
                    $('#frmResidualMatrixEdit').modal("hide");
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: EditResidualRiskMatrixPopup() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in EditResidualRiskMatrixPopup() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ChangeInScoringType(data, event) {
        try {
            if (data.ScoringType == "Inherent") {
                $('#isQuantitativeScale').show();
            }
            else if (data.ScoringType == "Final") {
                $('#isQuantitativeScale').hide();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in ChangeInScoringType() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function FinalCheckBoxClick(data, event) {
        try {
            if (event.currentTarget.checked) {
                $('#UsedToHideMultiselectDropDown').hide();
            }
            else {
                $('#UsedToHideMultiselectDropDown').show();
            }
            return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source:ajax call in FinalCheckBoxClick() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function saveRiskLevelPopup(data, event) {
        try {
            if (data.RiskLevelName == '') {
                $('#valErrorRA').show();
                $('#valErrorRA').text('Risk Scale Name cannot be left blank.');
                return false;
            }
            if (data.RiskLevelShortText == '') {
                $('#valErrorRA').show();
                $('#valErrorRA').text('Risk Scale Short Name cannot be left blank.');
                return false;
            }
            if (RlViewModel.ClickType() == "INH") {
                if (data.LevelCount == '') {
                    $('#valErrorRA').show();
                    $('#valErrorRA').text('No. of Levels cannot be left blank.');
                    return false;
                }
                else if (isNaN(parseInt(data.LevelCount))) {
                    $('#valErrorRA').show();
                    $('#valErrorRA').text('Please enter valid input for No. of Levels.');
                    return false;
                }
                else if (data.LevelCount < 0) {
                    $('#valErrorRA').show();
                    $('#valErrorRA').text('No. of Levels cannot be less than zero.');
                    return false;
                }
                var ApplicableZATIdString = "";
                if (RlViewModel.IsEditRiskLevel() === false) {      // while adding risk level
                    for (var i = 0; i < RlViewModel.SurveyCategoryList().length; i++) {
                        for (var j = 0; j < RlViewModel.SelectedSurveyCategoriesList().length; j++) {
                            if (RlViewModel.SelectedSurveyCategoriesList()[j] === RlViewModel.SurveyCategoryList()[i].SurveyCategoryId()) {
                                if (ApplicableZATIdString === "")
                                    ApplicableZATIdString += RlViewModel.SurveyCategoryList()[i].SurveyCategoryId().toString();
                                else
                                    ApplicableZATIdString += "," + RlViewModel.SurveyCategoryList()[i].SurveyCategoryId().toString();
                            }
                        }
                    }
                    if (ApplicableZATIdString === "" && data.ScoringType !== "Final") {
                        $('#valErrorRA').show();
                        $('#valErrorRA').text('The Scale should be applicable for atleast one Component. Please select applicability.');
                        return false;
                    }
                }
                else { // while updating risk level
                    ApplicableZATIdString = data.ApplicableZATIds;
                }
                for (var i = 0; i < RlViewModel.InherentRiskLevelList().length; i++) {
                    if (RlViewModel.InherentRiskLevelList()[i].ScoringType == "Final" && data.ScoringType == "Final") {
                        if (data.RiskLevelId != RlViewModel.InherentRiskLevelList()[i].RiskLevelId) {
                            $('#valErrorRA').show();
                            $('#valErrorRA').text('Only one final scale is allowed.');
                            return false;
                        }
                    }
                }
            }
            if (RlViewModel.ClickType() == "CTRL") {
                var isFinal = document.getElementById("isFinal").checked;
                if (isFinal) {
                    data.Type = 'Final';
                }
                else {
                    data.Type = 'Control';
                }
                if (RlViewModel.SelectedControlsResponseType().length <= 0 && !isFinal) {
                    $('#valErrorRA').text('The Scale should be applicable to atleast one.');
                }
                if (data.Type == 'Final') {
                    for (var i = 0; i < RlViewModel.ControlsRiskLevelList().length; i++) {
                        if (RlViewModel.ControlsRiskLevelList()[i].Type == "Final" && isFinal) {
                            $('#valErrorRA').show();
                            $('#valErrorRA').text('Only one final scale is allowed.');
                            return false;
                        }
                    }
                }
            }
            RlViewModel.AddInherentMatrix(false);
            $('#valErrorRA').hide();

            RlViewModel.AddInherentMatrix(true);
            if (data.RiskLevelId == null) {
                data.RiskLevelId = 0;
            }
            
            $('#valErrorRA').hide();
            var URL = "";
            if (RlViewModel.ClickType() == "INH") {
                data.ApplicableZATIds = ApplicableZATIdString;
                URL = "/api/Configuration/saveInherentRiskLevels";
            }
            if (RlViewModel.ClickType() == "CTRL") {
                URL = "/api/Configuration/saveControlsRiskLevels";
            }
            if (RlViewModel.ClickType() == "RES") {
                URL = "/api/Configuration/saveResidualRiskLevels";
            }
            if (data.RiskLevelName.length == 0 || data.RiskLevelName == "") {

            }
            else if (data.RiskLevelShortText.length == 0 || data.RiskLevelShortText == "") {

            }
            else if ((data.LevelCount == 0 || data.LevelCount == "") && RlViewModel.ClickType() != "CTRL" && RlViewModel.ClickType() != "RES") {

            }

            else {
                data.AssessmentId = RlViewModel.ClickedAssessmentTypeId();
                data.CRTDId = RlViewModel.SelectedControlsResponseType();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: URL,
                    type: "POST",
                    contentType: 'application/json',
                    headers: headers,
                    data: ko.toJSON(data)
                })
                    .success(function (jsonResult, status) {
                        if (jsonResult != null) {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                            }
                            else if (!isNaN(jsonResult) && parseInt(jsonResult) > 0) {
                                logger.logSuccess('Risk Scale has been added successfully.', 'Success', system.getModuleId(RlViewModel), true);
                                if (RlViewModel.ClickType() == "INH") {
                                    GetAllInherentLevels();
                                }
                                if (RlViewModel.ClickType() == "CTRL") {
                                    GetAllControlsLevels();
                                }
                                if (RlViewModel.ClickType() == "RES") {
                                    GetAllResidualLevels();
                                }

                                $('#frmCtrlRiskLevel').modal("hide");
                                $('#frmInhRiskLevel').modal("hide");
                                $('#frmSubFactor').modal('hide');
                            }
                            else if (jsonResult == "-99") {
                                logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                            }
                            else {
                                logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                            }
                        }
                        else {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                        }
                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveRiskLevelPopup() method in RiskLevel.js';
                            logger.logMessage(msg);
                        }
                    });
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveRiskLevelPopup() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function EmptyOrNumeric(value) {
        if (value === null || value === undefined || value === '') {
            return false;
        }
        else {
            return isNaN(value);
        }
    }
    function IRSSaveButton(data, event) {
        try {
            for (var i = 0; i < (RlViewModel.InherentRiskLevelList().length); i++) {
                $("#lblError" + RlViewModel.InherentRiskLevelList()[i].RiskLevelId).hide();
            }
            var test = "";
            var count = 0;
            var num_score = 0;
            var num_adj = 0;
            var ElementSequence;
            var IsValidate = true;
            var id = event.currentTarget.id.substring(('save').length + 1, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.InherentRiskLevelList().length); i++) {
                if (RlViewModel.InherentRiskLevelList()[i].RiskLevelId == parseInt(id)) {
                    ElementSequence = i;
                    var MappedModel = $.map(RlViewModel.InherentRiskLevelList()[i].MappedRiskLevels, function (result) {

                        if (result.RiskLevelDescription.length != 0 || result.RiskLevelDescription != "") {
                            if (result.RiskLevel < 0) {
                                count = -1;
                            }
                            else if (isNaN(result.RiskLevel)) {
                                num_score = 1;
                            }
                            else if (EmptyOrNumeric(result.RiskLevelAdj))
                            {
                                num_adj = 1;
                            }
                            result.RiskLevelParentId = id;
                            return new InherentRiskLevelModel(result);

                        }
                        else {
                            count = 1;
                        }
                       

                    })

                    if (count > 0) {
                        IsValidate = false;
                        break;
                    }

                    if (count < 0 || num_score == 1 || num_adj == 1) {
                        break;
                    }
                }

            }
                    
            if (IsValidate == false)
            {
                document.getElementById("lblError" + RlViewModel.InherentRiskLevelList()[ElementSequence].RiskLevelId).innerHTML = "You are required to set up all the risk levels.";
                $("#lblError" + RlViewModel.InherentRiskLevelList()[ElementSequence].RiskLevelId).show();
            }

            else if (count == -1)
            {
                $('#lblError' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId).show();
                document.getElementById("lblError" + RlViewModel.InherentRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Score cannot be negative";
                return false;
            }

            else if (num_score == 1) {
                $('#lblError' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId).show();
                document.getElementById("lblError" + RlViewModel.InherentRiskLevelList()[i].RiskLevelId).innerHTML = "Risk Score can not be a non-numeric value.";
                return false;
            }


            else if (num_adj == 1) {
                $('#lblError' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId).show();
                document.getElementById("lblError" + RlViewModel.InherentRiskLevelList()[i].RiskLevelId).innerHTML = "Rating adjustment can not be a non-numeric value.";
                return false;
            }


            else {
               
                $("#lblError" + RlViewModel.InherentRiskLevelList()[ElementSequence].RiskLevelId).hide()

                // validation for blank value
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/Configuration/saveIRSData",
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(MappedModel)
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }

                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajax call in IRSSaveButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }



                function ajaxSuccess(jsonResult, status) {
                    try {
                        if (jsonResult == "-99") {
                            logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                        }
                        else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                        }
                        else {
                            logger.logSuccess('Inherent Risk levels saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                        }
                        GetAllInherentLevels();
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in IRSSaveButton() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                };

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in IRSSaveButton() method in RiskLevel.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source:ajaxFail in IRSSaveButton() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }

                };
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IRSSaveButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function IRSCancelButton(data, event) {
        try {
            var id = event.currentTarget.id.substring(('cancel').length + 1, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.InherentRiskLevelListDup().length); i++) {
                if (RlViewModel.InherentRiskLevelListDup()[i].RiskLevelId == parseInt(id)) {

                    var MappedModel = $.map(RlViewModel.InherentRiskLevelListDup()[i].MappedRiskLevels, function (result) {
                        return new InherentRiskLevelModel(result);
                    })
                    for (var j = 0; j < RlViewModel.InherentRiskLevelList().length; j++) {
                        if (RlViewModel.InherentRiskLevelList()[j].RiskLevelId == RlViewModel.InherentRiskLevelListDup()[i].RiskLevelId) {
                            RlViewModel.InherentRiskLevelList()[j].MappedRiskLevels = MappedModel;
                            break;
                        }
                    }
                }
            }
            BindDynamicHtml();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IRSCancelButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------------------------------Logic for Residual Risk Level Starts here----------------------------------------------------------------------------------------------

    function RRSStart() {
        try {
            $('#loadingMainImgDiv').show();

            GetRRSData();

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRSStart() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetRRSData() {
        try {

            if (RlViewModel.CRSDataList().length == 0)
                GetCRSData();
            $('#tabsResidual').show();
            $("#tabsResidual").removeClass('ui-widget-content');
            $('#residualAccordion').show();
            $('#loadingMainImgDiv').hide();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetRRSData() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetStandardApplicationLevels() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetApplicationStandardLevels",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call GetStandardApplicationLevels() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    RlViewModel.StdAppLevelList([]);
                    var mappedStdList = $.map(jsonResult, function (result) {
                        return new IRSDataModel(result);
                    })
                    RlViewModel.StdAppLevelList(mappedStdList);
                }
                else {
                    document.getElementById('RRLMasterListDiv').innerHTML = "The Standard Application Risk Levels aren't configured.";
                    logger.logError('An error occurred. Please contact the Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of GetStandardApplicationLevels() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetStandardApplicationLevels() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of GetStandardApplicationLevels() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }
    function RRSDrpDwnChange(data, event) { }
    function RRSCancelButton() {
        try {
            GetAllRiskLevelMatrix();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRSCancelButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function RRMatrixSaveButton(data, event) {
        try {
            var ElementSequence;
            var id = event.currentTarget.id.substring(('Save').length + 1, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.MasterMatrixRiskLevelList().length); i++) {
                if (RlViewModel.MasterMatrixRiskLevelList()[i].ResidualMatrixId == parseInt(id)) {
                    ElementSequence = i;
                    var XAxisLevels = RlViewModel.MasterMatrixRiskLevelList()[i].XAxisLevels();
                    var YAxisLevels = RlViewModel.MasterMatrixRiskLevelList()[i].YAxisLevels();

                    RlViewModel.SelectedScoreMatrix([]);
                    for (var k = 0; k < YAxisLevels.length; k++) {
                        for (var f = 0; f < XAxisLevels.length; f++) {
                            var dataSelector = 'ResidualDDYX_' + YAxisLevels[k].LevelId() + '_' + XAxisLevels[f].LevelId();
                            var theDropDown = $('*[data-buid="' + dataSelector + '"]');
                            var resSelectedScore = theDropDown.data('levelid');
                            var resSelectedColor = theDropDown.data('currentcss');
                            console.log(resSelectedScore);
                            console.log(resSelectedColor);
                            RlViewModel.SelectedScoreMatrix.push(new SelectedScoreMatrixModel({ XValue: XAxisLevels[f].LevelId(), YValue: YAxisLevels[k].LevelId(), ResScore: resSelectedScore, RiskCSS: resSelectedColor }));
                        }
                    }

                }
            }
            if (RlViewModel.SelectedScoreMatrix().length > 0) {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SaveRRMatrixData",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(RlViewModel.SelectedScoreMatrix(), function (result) {
                        return { XAxisId: result.XValue, YAxisId: result.YValue, ResidualAxisId: result.ResScore, ResidualMatrixId: id, RiskCSS: result.RiskCSS };
                    }))
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call RRMatrixSaveButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult != "-1" && jsonResult != "0") {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                        }
                        else
                            logger.logSuccess('Successfully saved Residual Risk Setup Data.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else
                        logger.logError('An error occurred while saving the Selected Residual Risk Matrix Data. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else
                    logger.logError('An error occurred while saving the Selected Residual Risk Matrix Data. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of RRMatrixSaveButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RRMatrixSaveButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of RRMatrixSaveButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }








    function RRSSetupDeleteScaleButton(data, event) {
        try {
            app.showMessage('Are you sure you want to Delete this Residual Scale?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        RRSSetupDeleteScale(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRSSetupDeleteScaleButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function RRSSetupDeleteScale(data, event) {


        try {

            var ResidualScaleId = event.currentTarget.id.substring(('Delete').length, event.currentTarget.id.length);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/deleteRRSScale",
                headers: headers,
                data: { ResidualScaleId: ResidualScaleId },
                type: "GET",
                contentType: 'application/json',
                dataType: 'json',


            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in RRSSetupDeleteScale() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "1") {
                    GetAllResidualLevels();
                    logger.logSuccess('Residual Scale deleted successfully.', 'Success', system.getModuleId(RlViewModel), true);
                }
                else if (jsonResult == "2") {
                    logger.logWarning('The Residual Scale cannot be deleted as it has internal dependencies.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else {
                    logger.logError('An error occured.Please contact the Administrator', 'Error', system.getModuleId(RlViewModel), true);
                }
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of RRSSetupDeleteScale() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RRSSetupDeleteScale() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of RRSSetupDeleteScale() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

    }
        
    function CRSSetupDeleteButton(data) {
        try {
            app.showMessage('Are you sure you want to Delete this Rating?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option == 'Confirm') {
                        CRSDeleteButton(data);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSSetupDeleteButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }


    function CRSDeleteSetupButton(data, event) {
        try {
            app.showMessage('Are you sure you want to Delete this Controls Scale?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        CRSDeleteSetupScale(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSDeleteSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function CRSDeleteSetupScale(data, event) {


        try {

            var ControlScaleId = event.currentTarget.id.substring(('controldelete').length, event.currentTarget.id.length);
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/deleteCRSMatrixData",
                headers: headers,
                data: { ControlScaleId: ControlScaleId },
                type: "GET",
                contentType: 'application/json',
                dataType: 'json',


            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in CRSDeleteSetupScale() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "1") {
                    GetAllControlsLevels();
                    logger.logSuccess('Control Scale deleted successfully.', 'Success', system.getModuleId(RlViewModel), true);
                }
                else if (jsonResult == "2") {
                    logger.logWarning('The Control Scale cannot be deleted as it has internal dependencies.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else {
                    logger.logError('An error occured.Please contact the Administrator', 'Error', system.getModuleId(RlViewModel), true);
                }
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of CRSDeleteSetupScale() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CRSDeleteSetupScale() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of CRSDeleteSetupScale() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

    }



    function IRSDeleteSetupButton(data, event) {
        try {
            app.showMessage('Are you sure you want to Delete this Inherent Scale?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-primary autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        IRSDeleteButton(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IRSDeleteSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function IRSDeleteButton(data, event) {
        try {

            var scaleId = parseInt(event.currentTarget.id.substring(('Delete-Scale').length + 1, event.currentTarget.id.length));

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/deleteIRSMatrixData",
                headers: headers,
                data: { scaleId: scaleId },
                type: "GET",
                contentType: 'application/json',
                dataType: 'json',


            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call IRSDeleteButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "2") {
                    logger.logWarning('The Inherent Scale cannot be deleted as it has dependencies.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else if (jsonResult == "1") {
                    logger.logSuccess('Inherent Scale deleted successfully.', 'Sucess', system.getModuleId(RlViewModel), true);
                    GetAllInherentLevels();
                }
                else if (isNaN(jsonResult) && JsonResult.jsonResult(0, 3) == "INC") {
                    logger.logError(JsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else
                    logger.logError('An error occurred while deleting the Selected Inherent Scale. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of IRSDeleteButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Delete Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in IRSDeleteButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of IRSDeleteButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    //RRMatrixDeleteSetupButton
    function RRMatrixDeleteSetupButton(data, event) {
        try {
            app.showMessage('Are you sure you want to Delete this Residual Matrix?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        RRMatrixDeleteButton(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRMatrixDeleteSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function RRMatrixDEditSetupButton(data, event) {
        try {
            var id = event.currentTarget.id.substring(('edit-').length, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.MasterMatrixRiskLevelList().length); i++) {
                if (RlViewModel.MasterMatrixRiskLevelList()[i].ResidualMatrixId == parseInt(id)) {
                    var MappededitabelModel = new MasterParentRiskMatrixModel({ ResidualMatrixId: RlViewModel.MasterMatrixRiskLevelList()[i].ResidualMatrixId, ResidualMatrixName: RlViewModel.MasterMatrixRiskLevelList()[i].ResidualMatrixName, XAxisName: RlViewModel.MasterMatrixRiskLevelList()[i].XAxisName, YAxisName: RlViewModel.MasterMatrixRiskLevelList()[i].YAxisName, ResidualName: RlViewModel.MasterMatrixRiskLevelList()[i].ResidualName })
                    break;
                }
            } RlViewModel.EditableResidualScale();
            RlViewModel.addPopUpCss(false);
            RlViewModel.EditableResidualScale(MappededitabelModel);
            RlViewModel.popUpTitle("Edit Risk Matrix");

            $('#frmResidualMatrixEdit').modal("show")
            //$('#frmSubFactor').modal('show');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRMatrixDEditSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    //RRMatrixDeleteButton
    function RRMatrixDeleteButton(data, event) {
        try {

            var matrixId = parseInt(event.currentTarget.id.substring(('Delete').length + 1, event.currentTarget.id.length));
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/deleteRRMatrixData",
                headers: headers,
                data: { matrixId: matrixId },
                type: "GET",
                contentType: 'application/json',
                dataType: 'json',


            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call RRMatrixDeleteButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "1") {
                    logger.logSuccess('Successfully deleted Residual Risk Matrix.', 'Sucess', system.getModuleId(RlViewModel), true);
                    GetAllResidualLevels();
                }
                else if (jsonResult == "2") {
                    logger.logWarning('Residual Matrix is used in the application. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else
                    logger.logError('An error occurred while deleting the Selected Residual Risk Matrix Data. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of RRMatrixDeleteButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RRMatrixDeleteButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of RRMatrixDeleteButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function INHMatrixDeleteSetupButton(data, event) {
        try {
            app.showMessage('Are you sure you want to Delete this Inherent Matrix?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        INHMatrixDeleteButton(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: INHMatrixDeleteSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function CTRLMatrixDeleteSetupButton(data, event) {
        try {
            app.showMessage('Are you sure you want to Delete this Control Matrix?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        CTRLMatrixDeleteButton(data, event);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CTRLMatrixDeleteSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function INHMatrixEditSetupButton(data, event) {
        try {
            var id = event.currentTarget.id.substring(('edit-').length, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.InherentMasterMatrixRiskLevelList().length); i++) {
                if (RlViewModel.InherentMasterMatrixRiskLevelList()[i].InherentMatrixId == parseInt(id)) {
                    var MappededitabelModel = new InherentMasterParentRiskMatrixModel({ InherentMatrixId: RlViewModel.InherentMasterMatrixRiskLevelList()[i].InherentMatrixId, InherentMatrixName: RlViewModel.InherentMasterMatrixRiskLevelList()[i].InherentMatrixName, XAxisName: RlViewModel.InherentMasterMatrixRiskLevelList()[i].XAxisName, YAxisName: RlViewModel.InherentMasterMatrixRiskLevelList()[i].YAxisName, InherentAxisName: RlViewModel.InherentMasterMatrixRiskLevelList()[i].InherentAxisName })
                    break;
                }
            } RlViewModel.EditableInherentScale();
            RlViewModel.EditableInherentScale(MappededitabelModel);
            RlViewModel.popUpTitle("Edit Risk Matrix");

            $('#frmInherentMatrixEdit').modal("show");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: INHMatrixEditSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function CTRLMatrixEditSetupButton(data, event) {
        try {
            var id = event.currentTarget.id.substring(('edit-').length, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.ControlMasterMatrixRiskLevelList().length); i++) {
                if (RlViewModel.ControlMasterMatrixRiskLevelList()[i].ControlMatrixId == parseInt(id)) {
                    var MappededitabelModel = new ControlMasterParentRiskMatrixModel({ ControlMatrixId: RlViewModel.ControlMasterMatrixRiskLevelList()[i].ControlMatrixId, ControlMatrixName: RlViewModel.ControlMasterMatrixRiskLevelList()[i].ControlMatrixName, XAxisName: RlViewModel.ControlMasterMatrixRiskLevelList()[i].XAxisName, YAxisName: RlViewModel.ControlMasterMatrixRiskLevelList()[i].YAxisName, ControlAxisName: RlViewModel.ControlMasterMatrixRiskLevelList()[i].ControlAxisName, XPercentage: RlViewModel.ControlMasterMatrixRiskLevelList()[i].XPercentage, YPercentage: RlViewModel.ControlMasterMatrixRiskLevelList()[i].YPercentage })
                    break;
                }
            } RlViewModel.EditableControlScale();
            RlViewModel.EditableControlScale(MappededitabelModel);
            RlViewModel.popUpTitle("Edit Risk Matrix");

            $('#frmControlMatrixEdit').modal("show");


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CTRLMatrixEditSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function CTRLMatrixCancelSetupButton() {
        try {
            GetAllRiskLevelControlMatrix();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CTRLMatrixCancelSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function INHRMatrixCancelSetupButton() {
        try {
            GetAllRiskLevelInherentMatrix();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: INHRMatrixCancelSetupButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function INHMatrixDeleteButton(data, event) {
        try {

            var matrixId = parseInt(event.currentTarget.id.substring(('Delete').length + 1, event.currentTarget.id.length));
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/deleteINHRMatrixData",
                headers: headers,
                data: { matrixId: matrixId },
                type: "GET",
                contentType: 'application/json',
                dataType: 'json',


            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call INHMatrixDeleteButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "1") {
                    logger.logSuccess('Successfully deleted Inherent Risk Matrix.', 'Sucess', system.getModuleId(RlViewModel), true);
                    GetAllInherentLevels();
                    RlViewModel.InherentMasterMatrixRiskLevelList([]);
                }
                else if (jsonResult == "2") {
                    logger.logWarning('Inherent Risk Matrix can not be deleted as it is used in the application. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else
                    logger.logError('An error occurred while deleting the Selected Inherent Risk Matrix Data. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of INHMatrixDeleteButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in INHMatrixDeleteButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of INHMatrixDeleteButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function ChangePercent(data, event) {
        try {
            if (event.currentTarget.id == 'YPercentage') {
                event.currentTarget.parentNode.parentNode.children[2].children[2].value = String(100 - parseInt(event.currentTarget.value));
                RlViewModel.ControlScale().XPercentage = 100 - parseInt(event.currentTarget.value);
            }
            else {
                event.currentTarget.parentNode.parentNode.children[3].children[2].value = String(100 - parseInt(event.currentTarget.value));
                RlViewModel.ControlScale().YPercentage = 100 - parseInt(event.currentTarget.value);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of ChangePercent() in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ChangePercentEdit(data, event) {
        try {
            if (event.currentTarget.id == 'YPercentage1') {
                event.currentTarget.parentNode.parentNode.children[2].children[2].value = String(100 - parseInt(event.currentTarget.value));
                RlViewModel.EditableControlScale().XPercentage = 100 - parseInt(event.currentTarget.value);
            }
            else {
                event.currentTarget.parentNode.parentNode.children[3].children[2].value = String(100 - parseInt(event.currentTarget.value));
                RlViewModel.EditableControlScale().YPercentage = 100 - parseInt(event.currentTarget.value);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of ChangePercentEdit() in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function CTRLMatrixDeleteButton(data, event) {
        try {

            var matrixId = parseInt(event.currentTarget.id.substring(('Delete').length + 1, event.currentTarget.id.length));
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/deleteCTRLMatrixData",
                headers: headers,
                data: { matrixId: matrixId },
                type: "GET",
                contentType: 'application/json',
                dataType: 'json',


            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call CTRLMatrixDeleteButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "1") {
                    logger.logSuccess('Successfully deleted Controls Matrix.', 'Sucess', system.getModuleId(RlViewModel), true);
                    BindDynamicHtmlForControlMasterMatrixRatingLevel();
                    GetAllRiskLevelControlMatrix();
                    RlViewModel.ControlMasterMatrixRiskLevelList([]);
                }
                else if (jsonResult == "2") {
                    logger.logWarning('Control Matrix can not be deleted as it is used in the Application.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                    logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else
                    logger.logError('An error occurred while deleting the Selected Control Matrix Data. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of CTRLMatrixDeleteButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CTRLMatrixDeleteButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of CTRLMatrixDeleteButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function INHMatrixSaveButton(data, event) {
        try {
            var id = event.currentTarget.id.substring(('Save').length + 1, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.InherentMasterMatrixRiskLevelList().length); i++) {
                if (RlViewModel.InherentMasterMatrixRiskLevelList()[i].InherentMatrixId == parseInt(id)) {
                    ElementSequence = i;
                    var XAxisLevels = RlViewModel.InherentMasterMatrixRiskLevelList()[i].XAxisLevels();
                    var YAxisLevels = RlViewModel.InherentMasterMatrixRiskLevelList()[i].YAxisLevels();

                    RlViewModel.InherentSelectedScoreMatrix([]);
                    for (var k = 0; k < YAxisLevels.length; k++) {
                        for (var f = 0; f < XAxisLevels.length; f++) {

                            var inhSelectedScore = $('#InherentDDYX_' + YAxisLevels[k].LevelId() + '_' + XAxisLevels[f].LevelId()).val()
                            var inhSelectedColor = $('#InherentDDYX_' + YAxisLevels[k].LevelId() + '_' + XAxisLevels[f].LevelId() + ' :selected').attr('class');
                            RlViewModel.InherentSelectedScoreMatrix.push(new SelectedInherentScoreMatrixModel({ XValue: XAxisLevels[f].LevelId(), YValue: YAxisLevels[k].LevelId(), InhScore: inhSelectedScore, RiskCSS: inhSelectedColor }));
                        }
                    }

                }
            }
            if (RlViewModel.InherentSelectedScoreMatrix().length > 0) {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SaveINHRMatrixData",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(RlViewModel.InherentSelectedScoreMatrix(), function (result) {
                        return { XAxisId: result.XValue, YAxisId: result.YValue, InherentAxisId: result.InhScore, InherentMatrixId: id, RiskCSS: result.RiskCSS };
                    }))
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call INHMatrixSaveButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult != "-1" && jsonResult != "0") {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                        }
                        else
                            logger.logSuccess('Successfully saved Inherent Risk Setup Data.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                }
                else
                    logger.logError('An error occurred while saving the Selected Inherent Risk Matrix Data. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of INHMatrixSaveButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in INHMatrixSaveButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of INHMatrixSaveButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function CTRLMatrixSaveButton(data, event) {
        try {

            var ElementSequence;
            var id = event.currentTarget.id.substring(('Save').length + 1, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.ControlMasterMatrixRiskLevelList().length); i++) {
                if (RlViewModel.ControlMasterMatrixRiskLevelList()[i].ControlMatrixId == parseInt(id)) {
                    ElementSequence = i;
                    var XAxisLevels = RlViewModel.ControlMasterMatrixRiskLevelList()[i].XAxisLevels();
                    var YAxisLevels = RlViewModel.ControlMasterMatrixRiskLevelList()[i].YAxisLevels();

                    RlViewModel.ControlSelectedScoreMatrix([]);
                    for (var k = 0; k < YAxisLevels.length; k++) {
                        for (var f = 0; f < XAxisLevels.length; f++) {

                            var ctrlSelectedScore = $('#ControlDDYX_' + YAxisLevels[k].LevelId() + '_' + XAxisLevels[f].LevelId()).val()
                            var ctrlSelectedColor = $('#ControlDDYX_' + YAxisLevels[k].LevelId() + '_' + XAxisLevels[f].LevelId() + ' :selected').attr('class');
                            RlViewModel.ControlSelectedScoreMatrix.push(new SelectedControlScoreMatrixModel({ XValue: XAxisLevels[f].LevelId(), YValue: YAxisLevels[k].LevelId(), CtrlScore: ctrlSelectedScore, RiskCSS: ctrlSelectedColor }));
                        }
                    }

                }
            }
            if (RlViewModel.ControlSelectedScoreMatrix().length > 0) {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SaveCTRLMatrixData",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(RlViewModel.ControlSelectedScoreMatrix(), function (result) {
                        return { XAxisId: result.XValue, YAxisId: result.YValue, ControlAxisId: result.CtrlScore, ControlMatrixId: id, RiskCSS: result.RiskCSS };
                    }))
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call CTRLMatrixSaveButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult != "-1" && jsonResult != "0") {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                        }
                        else
                            logger.logSuccess('Successfully saved Control Matrix Data.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                }
                else
                    logger.logError('An error occurred while saving the Selected Control Matrix Data. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of CTRLMatrixSaveButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CTRLMatrixSaveButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of CTRLMatrixSaveButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function RRSSaveButton() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveRRSData",
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(RlViewModel.RRSDataList(), function (result) {
                    return { IRSId: result.IRSId(), CRSId: result.CRSId(), RRLId: result.RRLId(), RRLName: result.RRLName(), RRLCss: result.RRLCss() };
                }))
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {

            var msg = 'Exception: ' + e + ' | Source: ajax call RRSSaveButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != "-1") {
                    if (jsonResult == "-99") {
                        logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else if (jsonResult == "1") {
                        var mappedRRSDataDup = $.map(RlViewModel.RRSDataList(), function (result) {
                            return new RRLDataModel({ IRSId: result.IRSId(), CRSId: result.CRSId(), RRLId: result.RRLId(), RRLName: result.RRLName(), RRLCss: result.RRLCss() });
                        });
                        RlViewModel.RRSDataListDup(mappedRRSDataDup);

                        logger.logSuccess('Successfully saved Residual Risk Setup Data.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else if (jsonResult != null) {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC")
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else
                        logger.logError('An error occurred while saving the Residual Risk Setup Data. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else {
                    logger.logError('An error occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of RRSSaveButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RRSSaveButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of RRSSaveButton() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function RRLDataModel(item) {
        try {
            var self = this;
            self.RRLId = ko.observable(item.RRLId);
            self.RRLName = ko.observable($('<div/>').html(item.RRLName).text());
            self.RRLCss = ko.observable($('<div/>').html(item.RRLCss).text());
            self.IRSId = ko.observable(item.IRSId);
            self.CRSId = ko.observable(item.CRSId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRLDataModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    //------Setting the values for RRS Data
    function GetRRSSetupData() {
        try {
            return $.ajax({
                url: "/api/Configuration/GetRRSSetupData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetRRSSetupData() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length != 0) {
                    $('#lblRRSDescValidation').hide();
                    var mappedRRSSetupData = $.map(jsonResult, function (result) {
                        return new RRSSetupDataModel(result);
                    });
                    RlViewModel.RRSSetupDataList(mappedRRSSetupData);

                    var mappedRRSSetupData = $.map(jsonResult, function (result) {
                        return new RRSSetupDataModel(result);
                    });
                    RlViewModel.RRSSetupDataListDup(mappedRRSSetupData);
                }
                else {
                    RRSSetupAddButton();
                }
                RlViewModel.ReadyToClick(true);
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of GetRRSSetupData() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRRSSetupData() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of GetRRSSetupData() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function RRSSetupValidate(Data) {
        try {
            var ValidationResult = 0;
            var RRSSetupData = Data.MappedRiskLevels();
            for (var i = 0; i < RRSSetupData.length; i++) {
                var DescValidation = 0;
                for (var x = 0; x < i; x++) {
                    if (RRSSetupData[x].Description == RRSSetupData[i].Description) {
                        DescValidation++;
                    }
                }
                if (DescValidation > 0) {
                    $($('#tblRRSSetup' + Data.RRLId + ' tbody').find('tr').get(i)).find('#lblRRSDescValidation').text("Description cannot be a duplicate.");
                    $($('#tblRRSSetup' + Data.RRLId + ' tbody').find('tr').get(i)).find('#lblRRSDescValidation').show();

                    ValidationResult++;
                }
                else if (RRSSetupData[i].Description == "") {
                    $($('#tblRRSSetup' + Data.RRLId + ' tbody').find('tr').get(i)).find('#lblRRSDescValidation').text("Description cannot be left blank.");
                    $($('#tblRRSSetup' + Data.RRLId + ' tbody').find('tr').get(i)).find('#lblRRSDescValidation').show();

                    ValidationResult++;
                }
                else if (RRSSetupData[i].RRLRiskScore < 0) {
                    $('#lblRRSCommonValidation').show();
                    document.getElementById("lblRRSCommonValidation").innerHTML = "Rating Score cannot be negative"
                    ValidationResult++;
                }
                else {

                    $($('#tblRRSSetup' + Data.RRLId + ' tbody').find('tr').get(i)).find('#lblRRSDescValidation').hide();
                    $('#lblRRSCommonValidation').hide();
                }
            }
            if (ValidationResult > 0)
                return false;
            else
                return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRSSetupValidate() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function RRSSetupAddButton(data, event) {
        try {
            var id = event.currentTarget.id.substring(('Add').length, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.ResidualRiskLevelList().length); i++) {
                if (RlViewModel.ResidualRiskLevelList()[i].RRLId == parseInt(id)) {
                    if (RRSSetupValidate(RlViewModel.ResidualRiskLevelList()[i])) {


                        var mappedObject = new ResidualRiskLevelModel({ RiskLevelParentId: RlViewModel.ResidualRiskLevelList()[i].RRLId, Id: 0, Description: "", Comments: "", CSS: null })
                        RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels().push(mappedObject);
                        BindDynamicHtmlForResdiualRatingLevel();

                    }
                }
            }
            //control code ends here
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSAddButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function RRSSetupCancelButton(data, event) {
        try {
            var id = parseInt(event.currentTarget.id.substring(('Cancel').length, event.currentTarget.id.length));

            for (var i = 0; i < RlViewModel.ResidualRiskLevelListDup().length; i++) {
                if (RlViewModel.ResidualRiskLevelListDup()[i].RRLId == id) {
                    var mappedResidualData = $.map(RlViewModel.ResidualRiskLevelListDup()[i].MappedRiskLevels(), function (result) {
                        return new ResidualRiskLevelModel(result);
                    });
                    RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels(mappedResidualData);
                }

            }
            $('#lblRRSDescValidation').hide();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRSSetupCancelButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function RRSSetupEditButton(data, event) {
        try {
            var id = event.currentTarget.id.substring(('edit').length, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.ResidualRiskLevelList().length); i++) {
                if (RlViewModel.ResidualRiskLevelList()[i].RRLId == parseInt(id)) {
                    var MappededitabelModel = new RiskLevelModel({ RiskLevelId: RlViewModel.ResidualRiskLevelList()[i].RRLId, RiskLevelName: RlViewModel.ResidualRiskLevelList()[i].RRLName, RiskLevelShortText: RlViewModel.ResidualRiskLevelList()[i].RRLShortName })
                    break;
                }
            } RlViewModel.editaleRiskLevel();
            RlViewModel.editaleRiskLevel(MappededitabelModel);
            RlViewModel.popUpTitle("Edit Risk Scale");

            $('#frmCtrlRiskLevel').modal("show")

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRSSetupEditButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function RRSSetupSaveButton(data) {
        RlViewModel.AddNewRRSLevelCount(-1);
        var id = event.currentTarget.id.substring(('Save').length, event.currentTarget.id.length);
        for (var i = 0; i < (RlViewModel.ResidualRiskLevelList().length); i++) {
            if (RlViewModel.ResidualRiskLevelList()[i].RRLId == parseInt(id)) {
                if (RRSSetupValidate(RlViewModel.ResidualRiskLevelList()[i])) {
                    try {
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        var requestData = $.map(RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels(), function (result) {
                            return {
                                Id: result.Id,
                                Description: result.Description,
                                Comments: result.Comments,
                                CSS: result.CSS,
                                RiskLevelParentId: RlViewModel.ResidualRiskLevelList()[i].RRLId,
                                RRLRiskScore: result.RRLRiskScore,
                                RiskLevelAdj: result.RiskLevelAdj,
                                RiskLevelShortName: result.RiskLevelShortName
                            };
                        });
                        headers.__RequestVerificationToken = csrfToken;
                        $.ajax({
                            url: "/api/Configuration/SaveRRSSetupData",
                            headers: headers,
                            type: "POST",
                            contentType: 'application/json',
                            dataType: 'json',
                            data: JSON.stringify(requestData)
                        })
                            .success(ajaxSuccess)
                            .fail(ajaxFail);
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajax call in CRSSaveButton() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                }
            }
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult == "-99") {
                    RRSSetupCancelButton();
                    logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else if (jsonResult == "1") {
                    logger.logSuccess('Residual Rating saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                    GetAllResidualLevels();
                }
                else if (jsonResult != null) {
                    if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC")
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
                else {
                    RRSSetupCancelButton();
                    logger.logError('An error occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of CRSSaveButton() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CRSSaveButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of CRSSaveButton() method in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function RRSSetupDeleteButton(data) {
        try {
            app.showMessage('Are you sure you want to Delete this Rating?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        RRSSetupDelete(data);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRSSetupDataList() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function RRSSetupDelete(data) {
        if (data.Id == 0) {

            for (var i = 0; i < (RlViewModel.ResidualRiskLevelList().length); i++) {
                if (RlViewModel.ResidualRiskLevelList()[i].RRLId == data.RiskLevelParentId) {
                    var mappedObject = new ResidualRiskLevelModel({ RiskLevelParentId: data.RiskLevelParentId, Id: 0, Description: data.Description, Comments: data.Comments, CSS: data.CSS })
                    for (j = 0; j < RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels().length; j++) {
                        if (RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels()[j].Id == 0 && RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels()[j].Description == data.Description && RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels()[j].RiskLevelParentId == data.RiskLevelParentId && RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels()[j].Comments == data.Comments)
                            RlViewModel.ResidualRiskLevelList()[i].MappedRiskLevels().splice(j, 1);
                    }
                    BindDynamicHtmlForResdiualRatingLevel();
                }
            }

        }
        else if (data != undefined) {
            try {
                DeleteAjax = {
                    url: "/api/Configuration/DeleteRRSSetupData",
                    headers: appsecurity.getSecurityHeaders(),
                    type: "GET",
                    data: { "deleteId": data.Id }
                };
                $.ajax(DeleteAjax)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in RRSSetupDelete() method in RiskAreas.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == "1") {
                        logger.logSuccess('Residual Rating deleted successfully.', 'Success', system.getModuleId(RlViewModel), true);
                        GetAllResidualLevels();
                    }
                    else if (jsonResult == "2") {
                        logger.logWarning('Risk level is used in the application. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                        logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        RRSSetupCancelButton();
                        logger.logError('An error occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of RRSSetupDelete() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in RRSSetupDelete() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of RRSSetupDelete() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
        }
        else {
            app.showMessage("Delete operation has been terminated. There should be atleast one residual rating.", "Delete operation terminated", ["OK"], false, {
                buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
            }).then(function (option) {
                if (option == "OK") { }
            })
        }
    }

    function RRSSetupDataModel(item) {
        var self = this;

        self.Description = ko.observable($('<div/>').html(item.Description).text());
        self.CSS = ko.observable($('<div/>').html(item.CSS).text());


        self.Comments = ko.observable($('<div/>').html(item.Comments).text());
        self.Id = ko.observable(item.Id);
        if (RlViewModel.AddNewRRSLevelCount() == -1) {
            self.Flag = ko.observable('OLD');
        }
        else {
            self.Flag = ko.observable(item.Flag);
        }
        var ImagePath = self.CSS() + '.png';
        var CompletePath = '../../../Content/images/';

        self.imagePath = ko.observable((CompletePath).concat(ImagePath));
    }

    //-------------------------------------------------------Logic for Controls Risk Level Starts here----------------------------------------------------------------------------------------------

    var CRSTableObj = false;
    var PreviousMaxValue = 0;
    function CRSStart() {
        try {
            $('#loadingMainImgDiv').show();
            var PageType = "C"
            GetAllQualitativeRiskLevel(PageType).then(function () {
                GetCRSColorpalette(PageType).then(function () {
                    GetCRSData().then(function () {
                        $('#loadingMainImgDiv').hide();
                        $('#tabsControl').show();
                    })
                })
            })


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RRLDataModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetCRSColorpalette(PageType) {
        try {
            return $.ajax({
                url: "/api/Configuration/GetHeatMapColors",
                data: { "PageType": PageType },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetCRSColorpalette() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length != 0) {
                    var mappedCRSColorPalette = $.map(jsonResult, function (result) {
                        return new CRSColorPalette(result);
                    });
                    RlViewModel.CRSColorPaletteList(mappedCRSColorPalette);
                }
                else {
                    logger.logError('An error occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                }
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of GetCRSColorpalette() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetCRSColorpalette() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of GetCRSColorpalette() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function SetCRSOptionsClass(option, data) {
        try {
            ko.applyBindingsToNode(option, { css: data.RiskLevelCSS() }, data);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetCRSOptionsClass() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetRiskColorValue(data, event) {
        try {
            var element = $(event.currentTarget).parent().prev('.selected-risk-color').get(0);
            ko.applyBindingsToNode(element, { text: data.RiskLevelCSS(), css: data.RiskLevelCSS(), value: data.RiskLevelCSS() });

            $(function () { $(element).change() });

            $(element).next('.risk-color-dropdown-wrapper').addClass('risk-color-hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetRiskColorValue() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetResidualRiskColorValue(data, event) {
        try {
            var element = $(event.currentTarget).parent().prev('.residual-selected-risk-color').get(0);
            ko.applyBindingsToNode(element, { text: data.RiskLevelCSS(), css: data.RiskLevelCSS(), value: data.RiskLevelCSS() });

            $(function () { $(element).change() });

            $(element).next('.residual-risk-color-dropdown-wrapper').addClass('risk-color-hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetResidualRiskColorValue() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetResidualMatrixRiskColorValue(data, event) {
        try {

            var theDropdown = $('.currently-active');
            console.log("theDropdown");
            //Get the dropdown wrapper which was clicked
            var theDropdownWrapper = theDropdown.parent();


            var currentCss = theDropdownWrapper.data('currentcss');
            var optionCss = data.RiskCSS;
            var optionLvlId = data.LevelId;
            var optionDescription = data.LevelName;

            //apply the new levelId we gonna need it when we save the matrix
            theDropdownWrapper.data('levelid', optionLvlId);

            //remove the old class and update with the selected
            //this is how we know which class to remove on each new selection
            theDropdown.removeClass(currentCss);
            theDropdownWrapper.data('currentcss', optionCss);

            //add the selected risk level classAddMatrix
            theDropdown.addClass(optionCss);

            //change the text according to the selection
            theDropdown.text(optionDescription);

            //hide the options before the popup opens
            $('.residual-matrix-risk-color-dropdown-wrapper').addClass('risk-color-hide');

            //set the arrow down
            $('.risk-color-arrow').each(function () {
                if ($(this).hasClass('risk-color-arrow-up')) {
                    $(this).removeClass('risk-color-arrow-up');
                    $(this).addClass('risk-color-arrow-down');
                }
            })

            //no open dropdowns - remove the currently-active class
            $('.residual-matrix-selected-risk-color').each(function () {
                if ($(this).hasClass('currently-active')) {
                    $(this).removeClass('currently-active')
                }
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetResidualMatrixRiskColorValue() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetControlRiskColorValue(data, event) {
        try {
            var element = $(event.currentTarget).parent().prev('.control-selected-risk-color').get(0);
            ko.applyBindingsToNode(element, { text: data.RiskLevelCSS(), css: data.RiskLevelCSS(), value: data.RiskLevelCSS() });

            $(function () { $(element).change() });

            $(element).next('.control-risk-color-dropdown-wrapper').addClass('risk-color-hide');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetControlRiskColorValue() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SetRESOptionsClass(option, data) {
        try {
            ko.applyBindingsToNode(option, { css: data.RiskCSS }, data);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SetRESOptionsClass() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function GetCRSData() {
        try {

            return $.ajax({
                url: "/api/Configuration/GetCRSData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: RlViewModel.ClickedAssessmentTypeId() }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetCRSData() method in RiskLevel.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length != 0) {
                    var mappedCRSData = $.map(jsonResult, function (result) {
                        return new CRSDataModel(result);
                    });
                    RlViewModel.CRSDataList(mappedCRSData);
                    RlViewModel.FirstId = mappedCRSData[0].Id();
                    var mappedCRSDataDup = $.map(jsonResult, function (result) {
                        return new CRSDataModel(result);
                    });
                    RlViewModel.CRSDataListDup(mappedCRSDataDup);
                }
                else {
                    CRSAddButton();
                }
                applyControlsDDSLICK();
                RlViewModel.ReadyToClick(true);
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of GetCRSData() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetCRSData() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of GetCRSData() in RiskLevel.js';
                logger.logMessage(msg);
            }
        }
    }

    function applyControlsDDSLICK() {
        for (var i = 0; i < RlViewModel.CRSDataList().length; i++) {
            for (var j = 0; j < RlViewModel.QualitativeRiskLevelList().length; j++) {
                $('#CtrlDrpDown_' + RlViewModel.CRSDataList()[i].Id() + ' .' + RlViewModel.CRSColorPaletteList()[j].RiskLevelCSS() + '').attr('data-imagesrc', RlViewModel.ImagePathList()[j]);
                $('#CtrlDrpDown_' + RlViewModel.CRSDataList()[i].Id() + ' .' + RlViewModel.CRSColorPaletteList()[j].RiskLevelCSS() + '').text(RlViewModel.QualitativeRiskLevelList()[j].CSSName());

            }
        }
        if (RlViewModel.AddNewLevelCount() != -1) {

            for (var i = 0; i < RlViewModel.CRSDataList().length; i++) {
                for (var j = 0; j < RlViewModel.QualitativeRiskLevelList().length; j++) {
                    $('#CtrlDrpDown_' + RlViewModel.AddNewLevelCount()).attr('data-imagesrc', RlViewModel.ImagePathList()[j]);
                }
            }
            $('#CtrlDrpDown_' + RlViewModel.AddNewLevelCount()).ddslick({
                onSelected: function (selectedData) {
                    applyControlsCss();

                    for (var i = 0; i < RlViewModel.CRSDataList().length; i++) {
                        var selectedID = selectedData.original[0].id;
                        var selectedIDNumber = selectedID.match(/\d/g);
                        selectedIDNumber = selectedIDNumber.join("");

                        if (selectedIDNumber == RlViewModel.CRSDataList()[i].Id()) {
                            RlViewModel.CRSDataList()[i].CSS(selectedData.selectedData.imageSrc.substring(24, selectedData.selectedData.imageSrc.lastIndexOf('.')));
                            RlViewModel.CRSDataList()[i].imagePath(selectedData.selectedData.imageSrc);
                            break;
                        }
                    }
                }
            });
        }
        RlViewModel.controlcountEntry(false);
        for (var i = 0; i < RlViewModel.CRSDataList().length; i++) {
            $('#CtrlDrpDown_' + RlViewModel.CRSDataList()[i].Id() + '').ddslick({

                onSelected: function (selectedData) {
                    if (RlViewModel.controlcountEntry()) {
                        RlViewModel.controlcountEntry(true);
                        applyControlsCss();
                        for (var i = 0; i < RlViewModel.CRSDataList().length; i++) {
                            var selectedID = selectedData.original[0].id;
                            var selectedIDNumber = selectedID.match(/\d/g);
                            selectedIDNumber = selectedIDNumber.join("");

                            if (selectedIDNumber == RlViewModel.CRSDataList()[i].Id()) {
                                RlViewModel.CRSDataList()[i].CSS(selectedData.selectedData.imageSrc.substring(24, selectedData.selectedData.imageSrc.lastIndexOf('.')));
                                RlViewModel.CRSDataList()[i].imagePath(selectedData.selectedData.imageSrc);
                                break;
                            }
                        }
                    }
                }

            });

        }
        applyControlsCss();
        RlViewModel.controlcountEntry(true);
    }

    function applyControlsCss() {
        $("#CRSSetupDropDownID .dd-container .dd-select").css('width', '16em');
        $("#CRSSetupDropDownID .dd-container .dd-select").css('height', '3em');
        $("#CRSSetupDropDownID .dd-container .dd-option").css('height', '3em');
        $("#CRSSetupDropDownID .dd-container .dd-options").css('width', '16em');
        $("#CRSSetupDropDownID .dd-container .dd-selected-image").css('width', '7em');
        $("#CRSSetupDropDownID .dd-container .dd-selected-image ").css('max-height', '2.5em');
        $("#CRSSetupDropDownID .dd-container .dd-selected-image ").css('max-width', '15.3em');
        $("#CRSSetupDropDownID .dd-container .dd-selected-image ").css('border-radius', '0.3em');
        $("#CRSSetupDropDownID .dd-container .dd-selected-image ").css('margin-left', '0.2em');
        $("#CRSSetupDropDownID .dd-container .dd-selected-image ").css('margin-right', '0.2em');
        
        $("#CRSSetupDropDownID .dd-container .dd-option-image").css('width', '7em');
        $("#CRSSetupDropDownID .dd-container .dd-option-image").css('max-height', '2.5em');
        $("#CRSSetupDropDownID .dd-container .dd-option-image").css('max-width', '15.3em');
        $("#CRSSetupDropDownID .dd-container .dd-option-image").css('border-radius', '0.3em');
        $("#CRSSetupDropDownID .dd-container .dd-option-image").css('margin-left', '0.2em');
        $("#CRSSetupDropDownID .dd-container .dd-option-image").css('margin-right', '0.2em');
        $("#CRSSetupDropDownID .dd-container .dd-option-image").css('height', '2em');
        
        $("#CRSSetupDropDownID .dd-container .dd-option-selected").css('width', '15.3em');
        $("#CRSSetupDropDownID .dd-container .dd-option-selected").css('max-height', '2.5em');
        $("#CRSSetupDropDownID .dd-container .dd-option-selected").css('max-width', '16em');
        $("#CRSSetupDropDownID .dd-container .dd-option-selected").css('border-radius', '0.3em');
        $("#CRSSetupDropDownID .dd-container .dd-option-selected").css('margin-left', '0.2em');
        $("#CRSSetupDropDownID .dd-container .dd-option-selected").css('margin-right', '0.2em');
        
        $("#CRSSetupDropDownID .dd-container .dd-option").css('width', '16em');
        $("#CRSSetupDropDownID .dd-container .dd-option").css('max-height', '2.5em');
        $("#CRSSetupDropDownID .dd-container .dd-option").css('max-width', '16em');
        $("#CRSSetupDropDownID .dd-container .dd-option").css('border-radius', '0.3em');
        $("#CRSSetupDropDownID .dd-container .dd-option").css('margin-left', '0.2em');
        $("#CRSSetupDropDownID .dd-container .dd-option").css('margin-right', '0.2em');
        $("#CRSSetupDropDownID .dd-container .dd-option").css('padding', '0em');
        
        $("#CRSSetupDropDownID .dd-container .dd-options").css('width', '16em');
        $("#CRSSetupDropDownID .dd-container .dd-options").css('max-height', '30em');
        $("#CRSSetupDropDownID .dd-container .dd-options").css('max-width', '16em');
        $("#CRSSetupDropDownID .dd-container .dd-options").css('border-radius', '0.3em');
        $("#CRSSetupDropDownID .dd-container .dd-options").css('margin-left', '0.2em');
        $("#CRSSetupDropDownID .dd-container .dd-options").css('margin-right', '0.2em');
        $("#CRSSetupDropDownID .dd-container .dd-options").css('overflow', 'hidden');
        
        $("#CRSSetupDropDownID .dd-container a img").css('width', '7em');
        $("#CRSSetupDropDownID .dd-container a img").css('max-height', '2.5em');
        $("#CRSSetupDropDownID .dd-container a img").css('max-width', '15.3em');
        
        $("#CRSSetupDropDownID .dd-container .dd-selected-text").css('margin-top', "0.6em");
        $("#CRSSetupDropDownID .dd-container .dd-selected-text").css('margin-left', "1em");
        $("#CRSSetupDropDownID .dd-container .dd-selected-text").css('line-height', "");
        $("#CRSSetupDropDownID .dd-container .dd-option-text").css('height', "2em");
        $("#CRSSetupDropDownID .dd-container .dd-option-text").css('line-height', "");
        $("#CRSSetupDropDownID .dd-container .dd-option-text").css('margin-top', "0.3em");
        $("#CRSSetupDropDownID .dd-container .dd-option-text").css('margin-left', "1em");
        $("#CRSSetupDropDownID .dd-container").css('width', '100%');
    }

    function CRSAddButton(data, event) {
        try {

            var isValidate = true;
            var id = event.currentTarget.id.substring(('controlAdd').length, event.currentTarget.id.length);
            var defaultCss = 'heatmap-dullgreen';

            for (var i = 0; i < (RlViewModel.ControlsRiskLevelList().length); i++) {
                if (RlViewModel.ControlsRiskLevelList()[i].RiskLevelId == parseInt(id)) {
                    $('#lblCommonValidation' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).hide();
                    if (RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels.length == 0) {
                        if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'P') {
                            var rowid = RlViewModel.ControlsRiskLevelList()[i].RiskLevelId + "-0";
                            var mappedObject = new ControlsRiskLevelModel({ RowId: rowid, RiskLevelParentId: RlViewModel.ControlsRiskLevelList()[i].RiskLevelId, Max: 100, Description: "", CSS: defaultCss, RiskLevelCSS: defaultCss })

                        }
                        else
                            var mappedObject = new ControlsRiskLevelModel({ RiskLevelParentId: RlViewModel.ControlsRiskLevelList()[i].RiskLevelId, Min: 0, Description: "", CSS: defaultCss, RiskLevelCSS: defaultCss })
                        RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels.push(mappedObject);
                        BindDynamicHtmlforControls();

                    }
                    else {
                        for (var j = 0; j < RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels.length; j++) {
                            if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'P' && RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Description.length == 0 || RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Min == undefined || isNaN(RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Min) == true) {
                                $('#lblCommonValidation' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                                document.getElementById("lblCommonValidation" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Please enter all the fields!"
                                isValidate = false;
                                break;
                            }
                            else if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'N' && RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Description.length == 0 || RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Max == undefined || isNaN(RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Max) == true) {
                                $('#lblCommonValidation' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                                document.getElementById("lblCommonValidation" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Please enter all the fields!"
                                isValidate = false;
                                break;
                            }
                            else if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'R' && RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Description.length == 0 || RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Max == undefined || isNaN(RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[j].Max) == true) {
                                $('#lblCommonValidation' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                                document.getElementById("lblCommonValidation" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Please enter all the fields!"
                                isValidate = false;
                                break;
                            }
                        }
                        if (isValidate) {
                            if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'P') {

                                let countDecimal = 0;
                                let value = RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels.length - 1].Min;
                                if (Math.floor(value) !== value)
                                    countDecimal = value.toString().split(".")[1].length || 0;


                                if (RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels.length - 1].Min > 0) {
                                    var rowid = String(RlViewModel.ControlsRiskLevelList()[i].RiskLevelId) + "-" + String(j);

                                    var mappedObject = new ControlsRiskLevelModel({
                                        RowId: rowid, RiskLevelParentId: RlViewModel.ControlsRiskLevelList()[i].RiskLevelId, Description: "",
                                        Max: value - Math.pow(10, -1 * countDecimal),
                                        CSS: defaultCss, RiskLevelCSS: defaultCss
                                    })
                                }
                                else {
                                    logger.logWarning('No more rows can be added as the minimum value is 0.', 'Error', system.getModuleId(RlViewModel), true);
                                    break;
                                }
                            }
                            else if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'R')
                                var mappedObject = new ControlsRiskLevelModel({ RiskLevelParentId: RlViewModel.ControlsRiskLevelList()[i].RiskLevelId, Description: "", Min: parseFloat(RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels.length - 1].Max + 0.00001).toFixed(5) })

                            else
                                var mappedObject = new ControlsRiskLevelModel({ RiskLevelParentId: RlViewModel.ControlsRiskLevelList()[i].RiskLevelId, Description: "", Min: parseFloat(RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels[RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels.length - 1].Max + 0.00001).toFixed(5), CSS: defaultCss, RiskLevelCSS: defaultCss })

                            RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels.push(mappedObject);
                            BindDynamicHtmlforControls();
                        }
                    }

                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSAddButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function InhAddButton(data, event) {
        try {

            var isValidate = true;
            var id = event.currentTarget.id.substring(('Add').length, event.currentTarget.id.length);
            var defaultCss = 'heatmap-dullgreen';

            for (var i = 0; i < (RlViewModel.InherentRiskLevelList().length); i++) {
                if (RlViewModel.InherentRiskLevelList()[i].RiskLevelId == parseInt(id)) {
                    $('#lblCommonValidation' + RlViewModel.InherentRiskLevelList()[i].RiskLevelId).hide();

                    var mappedObjectIn = new InherentRiskLevelModel({ RiskLevelParentId: RlViewModel.InherentRiskLevelList()[i].RiskLevelId, Description: "", CSS: defaultCss, RiskLevelCSS: defaultCss, RiskLevelDescription: "" });

                    RlViewModel.InherentRiskLevelList()[i].MappedRiskLevels.push(mappedObjectIn);
                    BindDynamicHtml();

                }

            }
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InhAddButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function InhSetupDeleteButton(data) {
        try {
            app.showMessage('Are you sure you want to Delete this Rating?' + "<br/><br/>", 'Delete Request', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-info", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option == 'Confirm') {
                        InhDeleteButton(data);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InhSetupDeleteButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }

    }

    function InhDeleteButton(data, event) {
        try {
            var InherentLevelId = data.RiskLevelId;
            var InherentScaleId = data.RiskLevelParentId;


            try {
                var headers = appsecurity.getSecurityHeaders();
                $.ajax({
                    url: "/api/Configuration/DeleteInhData",
                    headers: headers,
                    type: "GET",
                    data: { InherentLevelId: InherentLevelId, InherentScaleId: InherentScaleId }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InhDeleteButton() method in RiskLevel.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == "1") {
                        RlViewModel.IsRowDelete(true);
                        logger.logSuccess('Inherent Rating deleted successfully.', 'Success', system.getModuleId(RlViewModel), true);
                        GetAllInherentLevels().then(function () {
                            RlViewModel.IsRowDelete(false);
                        })
                    }
                    else if (jsonResult == "2") {
                        IRSCancelButton();
                        logger.logWarning('The Inherent Rating Cannot be deleted as it is used in the application.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else if (jsonResult != null) {
                        if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") 
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        logger.logError('An error occured. Please contact the Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of InhDeleteButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CRSDeleteButton() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of CRSDeleteButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSDeleteButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function CRSDeleteButton(data, event) {
        try {
            var ControlLevelId = data.Id;
            var ControlScaleId = data.RiskLevelParentId;


            try {
                var headers = appsecurity.getSecurityHeaders();
                $.ajax({
                    url: "/api/Configuration/DeleteCRSData",
                    headers: headers,
                    type: "GET",
                    data: { ControlLevelId: ControlLevelId, ControlScaleId: ControlScaleId }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in CRSDeleteButton() method in RiskLevel.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == "1") {
                        GetAllControlsLevels();
                        logger.logSuccess('Control Rating deleted successfully.', 'Success', system.getModuleId(RlViewModel), true);
                    }
                    else if (jsonResult == "2") {
                        CRSCancelButton();
                        logger.logWarning('The Control Rating Cannot be deleted as it is used in the application.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else if (jsonResult != null) {
                        if(isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC")
                            logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                    }
                    else {
                        logger.logError('An error occured.Please contact the Administrator', 'Error', system.getModuleId(RlViewModel), true);
                    }
                }

                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of CRSDeleteButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CRSDeleteButton() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of CRSDeleteButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSDeleteButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function CRSEditButton(data, event) {
        try {
            var id = event.currentTarget.id.substring(('controledit').length, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.ControlsRiskLevelList().length); i++) {
                if (RlViewModel.ControlsRiskLevelList()[i].RiskLevelId == parseInt(id)) {
                    var MappededitabelModel = new RiskLevelModel({ RiskLevelId: RlViewModel.ControlsRiskLevelList()[i].RiskLevelId, RiskLevelName: RlViewModel.ControlsRiskLevelList()[i].RiskLevelName, RiskLevelShortText: RlViewModel.ControlsRiskLevelList()[i].RiskLevelShortText, CRTDId: RlViewModel.SelectedControlsResponseType() })
                    break;
                }
            } RlViewModel.editaleRiskLevel();
            RlViewModel.editaleRiskLevel(MappededitabelModel);
            RlViewModel.popUpTitle("Edit Risk Scale");
            RlViewModel.addPopUpCtrlCss(false);
            $('#frmCtrlRiskLevel').modal("show");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSEditButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }


    function CRSCancelButton() {
        try {
            var id = event.currentTarget.id.substring(('controlcancel').length, event.currentTarget.id.length);
            for (var i = 0; i < (RlViewModel.ControlsRiskLevelListDup().length); i++) {
                if (RlViewModel.ControlsRiskLevelListDup()[i].RiskLevelId == parseInt(id)) {

                    var MappedModel = $.map(RlViewModel.ControlsRiskLevelListDup()[i].MappedRiskLevels, function (result) {
                        return new ControlsRiskLevelModel(result);
                    })
                    for (var j = 0; j < RlViewModel.ControlsRiskLevelList().length; j++) {
                        if (RlViewModel.ControlsRiskLevelList()[j].RiskLevelId == RlViewModel.ControlsRiskLevelListDup()[i].RiskLevelId) {
                            RlViewModel.ControlsRiskLevelList()[j].MappedRiskLevels = MappedModel;
                            break;
                        }
                    }
                }
            }
            BindDynamicHtmlforControls();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IRSCancelButton() method in RiskLevel.js';
            logger.logMessage(msg);

        }
    }

    function CRSSaveButton(data, event) {
        try
        {
            for (var i = 0; i < (RlViewModel.ControlsRiskLevelList().length); i++) {
                $("#lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).hide();
            }
            //var count = 0;
            
            var test = "";
            var id = event.currentTarget.id.substring(('contolsave').length + 1, event.currentTarget.id.length);
            var isValid = false;
            var min = 100;
            var num_score = 0;
            var num_adj = 0;

            for (var i = 0; i < (RlViewModel.ControlsRiskLevelList().length); i++) {
                min = 100;
                if (RlViewModel.ControlsRiskLevelList()[i].RiskLevelId == parseInt(id)) {

                    var MappedModel = $.map(RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels, function (result) {
                        result.RiskLevelParentId = id;
                        return new ControlsRiskLevelModel(result);
                    })

                    if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'P') {
                        for (var k = 0; k < MappedModel.length; k++) {
                            if (isNaN(MappedModel[k].Min))
                            { num_score = 1 }
                            if (EmptyOrNumeric(MappedModel[k].RiskLevelAdj))
                            { num_adj = 1 }

                            if (parseInt(MappedModel[k].Min) < min)
                                min = parseInt(MappedModel[k].Min);
                        }

                        if (CRSValidate(RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels) && min == 0) {
                            isValid = true;
                        }
                        else if (min != 0)
                        {
                            $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                            document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Minimum value should be 0."
                            isValid = false;
                        }

                    if (num_score == 1) {
                            $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                            document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Score cannot be a non-numeric value."
                            isValid = false;
                        }
                        else if (min < 0) {
                            $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                            document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Score cannot be negative."
                            isValid = false;
                        }
                        else if (num_adj == 1) {
                            $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                            document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Adjustment can not be a non-numeric value."
                            isValid = false;
                        }
                   
                    }

                    else if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'N') {

                        for (var j = 0; j < MappedModel.length; j++) {
                            if (isNaN(MappedModel[j].Max))
                            { num_score = 1 }
                            if (EmptyOrNumeric(MappedModel[j].RiskLevelAdj))
                            { num_adj = 1 }
                            if (MappedModel[j].Max == undefined || MappedModel[j].Description == "") {
                                $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                                document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Please enter values for all the fields!"
                                isValid = false;
                                break;
                            }
                            else if (MappedModel[j].Max < 0) {
                                $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                                document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Score cannot be negative"
                                isValid = false;
                            }
                            else if (num_score == 1) {
                                $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                                document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Score cannot be a non-numeric value."
                                isValid = false;
                            }
                            else if (num_adj == 1) {
                                $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                                document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Adjustment can not be a non-numeric value."
                                isValid = false;
                            }

                            else {
                                isValid = true;
                            }
                        }

                    }

                    else if (RlViewModel.ControlsRiskLevelList()[i].ScaleType == 'R') {
                        for (var k = 0; k < MappedModel.length; k++) {
                            if (isNaN(MappedModel[k].Min)) { num_score = 1 }
                            if (EmptyOrNumeric(MappedModel[k].RiskLevelAdj)) { num_adj = 1 }

                            if (parseInt(MappedModel[k].Min) < min)
                                min = parseInt(MappedModel[k].Min);
                        }

                        if (CRSValidate(RlViewModel.ControlsRiskLevelList()[i].MappedRiskLevels)) {
                            isValid = true;
                        }
                       
                        if (num_score == 1) {
                            $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                            document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Score cannot be a non-numeric value."
                            isValid = false;
                        }
                        else if (min < 0) {
                            $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                            document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Score cannot be negative."
                            isValid = false;
                        }
                        else if (num_adj == 1) {
                            $('#lblCommonValidationAdd' + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).show();
                            document.getElementById("lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).innerHTML = "Rating Adjustment can not be a non-numeric value."
                            isValid = false;
                        }

                    }
                    else {
                        isValid = true;
                    }
                    break;
                }
            }

            if (isValid) {
                for (var i = 0; i < (RlViewModel.ControlsRiskLevelList().length); i++) {
                    $("#lblCommonValidationAdd" + RlViewModel.ControlsRiskLevelList()[i].RiskLevelId).hide();
                }
                try {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/Configuration/SaveCRSData",
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify(MappedModel)
                    })
                        .success(ajaxSuccess)
                        .fail(ajaxFail);
                }

                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajax call in CRSSaveButton() method in RiskLevel.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, status) {
                    try {
                        if (jsonResult == "-99") {
                            CRSCancelButton();
                            logger.logError('An error occurred while saving Comments. Because Comment contain some invalid characters.', 'Error', system.getModuleId(RlViewModel), true);
                        } else if (jsonResult != null) {
                            if (isNaN(jsonResult) && jsonResult.substring(0, 3) == "INC") {
                                logger.logError(jsonResult + ' - An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                            }
                            else {
                                GetAllControlsLevels();
                                if (id == undefined || id == "")
                                    id = "";

                                $('#lblCommonValidation' + '_' + id).hide();
                                $('#lblCommonValidationAdd' + '_' + id).hide();

                                logger.logSuccess('Control Rating saved successfully.', 'Success', system.getModuleId(RlViewModel), true);
                            }
                        }
                        else {
                            CRSCancelButton();
                            logger.logError('An error occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(RlViewModel), true);
                        }
                    }

                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method of CRSSaveButton() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in CRSSaveButton() method in RiskLevel.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method of CRSSaveButton() method in RiskLevel.js';
                        logger.logMessage(msg);
                    }
                }
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSSaveButton() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function MinValueClick(data, event) {
        PreviousMaxValue = parseFloat(data.Min);
    }

    // blur event for control risk level setup
    function MinValueBlur(data, event) {
        try {

            var SelectedRow = event.currentTarget.parentNode.parentNode.parentNode;
            var targetValue = "";
            var SelectedRowIndex = $('#tblCRS tbody').find(SelectedRow).index();
            var TableLength = $('#tblCRS tbody').find('tr').length;
            var ChangedValue = parseFloat(event.currentTarget.value);
            if (event.currentTarget.parentNode.parentNode.parentNode.parentNode != undefined) {
                targetValue = event.currentTarget.parentNode.parentNode.parentNode.parentNode.getAttribute('data-bind').split("[").slice(1, 2)[0].charAt(0);
            }

            if (targetValue != "" && RlViewModel.ControlsRiskLevelList()[targetValue] != undefined && RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels != null) {


                RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex].Min = ChangedValue;
                if (SelectedRowIndex != (TableLength - 1)) {
                    if (ChangedValue == 0) {
                        app.showMessage('This action will delete the rest of the rows after this row. Click "Yes" to delete the rest of the rows or click "No" to go back and re-enter the Minimum Value.', 'Confirm Action', ['Yes', 'No'])
                            .then(function (option) {
                                if (option === 'Yes') {

                                    if (TableLength > 1) {
                                        RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels.splice(SelectedRowIndex + 1, TableLength - 1);
                                        for (var k = 1; k < TableLength; k++) {
                                            event.currentTarget.parentNode.parentNode.parentNode.parentNode.childNodes[SelectedRowIndex + k] = "";
                                        }
                                    }
                                }
                                else if (option == "No") {
                                    if (PreviousMaxValue == "" || PreviousMaxValue == "undefined")
                                        PreviousMaxValue = 0;

                                    event.currentTarget.value = PreviousMaxValue;
                                    event.currentTarget.focus();
                                }
                            });
                    }
                    else if (ChangedValue >= RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex].Max) {
                        app.showMessage('Updated value must be less than Max value.', 'Confirm Action', ['Ok'])
                            .then(function (option) {
                                if (option === 'Ok') {
                                    event.currentTarget.focus();
                                }
                            });
                    } else {
                        if (RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex + 1] != undefined) {

                            var num = 0;
                            if (Math.floor(ChangedValue) !== ChangedValue)
                                num = ChangedValue.toString().split(".")[1].length || 0; // Number of Decimal Points
                            else num = 0;

                            RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex + 1].Max = ChangedValue - Math.pow(10, -1*num);
                            RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex].Min = ChangedValue;
                            event.currentTarget.parentNode.parentNode.parentNode.parentNode.childNodes[SelectedRowIndex + 1].children[0].firstElementChild.firstElementChild.value = ChangedValue - 1;
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: MinValueBlur() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function MaxCheckDecimal(data, event) {
        try {
            var d = parseFloat(data.Max).toFixed(5);
            data.Max = d;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: MaxCheckDecimal() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }


    function MinCheckDecimal(data, event) {
        try {
            data.Min = parseFloat(data.Min).toFixed(5);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: MinCheckDecimal() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function MaxValueBlur(data, event) {
        try {

            var SelectedRow = event.currentTarget.parentNode.parentNode.parentNode;
            var targetValue = "";
            var SelectedRowIndex = $('#tblCRS tbody').find(SelectedRow).index();
            var TableLength = $('#tblCRS tbody').find('tr').length;
            var ChangedValue = parseFloat(event.currentTarget.value);
            if (event.currentTarget.parentNode.parentNode.parentNode.parentNode != undefined) {
                targetValue = event.currentTarget.parentNode.parentNode.parentNode.parentNode.getAttribute('data-bind').split("[").slice(1, 2)[0].charAt(0);
            }

            if (targetValue != "" && RlViewModel.ControlsRiskLevelList()[targetValue] != undefined && RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels != null) {
                if (RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex].Min <= ChangedValue) {
                    RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex].Max = ChangedValue;
                    if (SelectedRowIndex != (TableLength - 1)) {
                        if (RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex + 1] != undefined) {
                            RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex + 1].Min = 0;
                            RlViewModel.ControlsRiskLevelList()[targetValue].MappedRiskLevels[SelectedRowIndex].Max = ChangedValue;
                        }

                    }

                }
                else {
                    app.showMessage("Updated value must be greater than previous score.", "Error in Input Value", ["OK"], false, { buttonClass: "fa fa-check btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-exclamation-circle' })
                        .then(function (option) {
                            if (option === 'Ok') {
                                event.currentTarget.focus();
                            }
                        });
                }


            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: MaxValueBlur() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }



    function QRSValidate() {
        try {
            var ValidationResult = 0;
            var QRSData = RlViewModel.QRSDataList();
            for (var i = 0, j = QRSData.length; i < j; i++) {
                var DescValidation = 0;
                for (var x = 0; x < i; x++) {
                    if (RlViewModel.QRSDataList()[x].Description() == RlViewModel.QRSDataList()[i].Description()) {
                        DescValidation++;
                    }
                }
                if (QRSData[i].Description == "") {
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblValidation').text("Maximum value is required.");
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblValidation').show();
                    ValidationResult++;
                }
                else if (QRSData[i].Description().length > 20) {
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblValidation').text("Response description should be less than 20 characters.");
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblValidation').show();
                    ValidationResult++;
                }
                else if (DescValidation > 0) {
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblValidation').text("Description cannot be a duplicate.");
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblValidation').show();
                    ValidationResult++;
                }
                else if (QRSData[i].Level() === undefined) {
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblddValidation').text("Select the Inherent Risk level.");
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblddValidation').show();
                    ValidationResult++;
                }
                else {
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblValidation').hide();
                    $($('#tblQRS tbody').find('tr').get(i)).find('#lblddValidation').hide();
                }
            }
            if (ValidationResult > 0)
                return false;
            else
                return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QRSValidate() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function IRSValidate() {
        try {
            var ValidationResult = 0;
            var IRSData = RlViewModel.IRSDataList1();
            for (var i = 0, j = IRSData.length; i < j; i++) {
                var DescValidation = 0;
                for (var x = 0; x < i; x++) {
                    if (RlViewModel.IRSDataList1()[x].Description() == RlViewModel.IRSDataList1()[i].Description() && RlViewModel.IRSDataList1()[x].Description() != "") {
                        DescValidation++;
                    }
                }
                if (DescValidation > 0) {
                    $($('#tblIRS tbody').find('tr').get(i)).find('#lblValidation').text("Description cannot be a duplicate.");
                    $($('#tblIRS tbody').find('tr').get(i)).find('#lblValidation').show();
                    ValidationResult++;
                }
                else if (IRSData[i].Description().length > 20) {
                    $($('#tblIRS tbody').find('tr').get(i)).find('#lblValidation').text("Description should not be greater than 20 characters.");
                    $($('#tblIRS tbody').find('tr').get(i)).find('#lblValidation').show();
                    ValidationResult++;
                }
                else {
                    $($('#tblIRS tbody').find('tr').get(i)).find('#lblValidation').hide();
                }
            }
            if (ValidationResult > 0)
                return false;
            else
                return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: IRSValidate() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function CRSValidate(CRSData) {
        try {
            var ValidationResult = 0;
            var ValidationResult = 0;

            for (var i = 0, j = CRSData.length; i < j; i++) {
                var DescValidation = 0;
                for (var x = 0; x < i; x++) {
                    if (CRSData[x].Description == CRSData[i].Description) {
                        DescValidation++;
                    }
                }
                if (CRSData[i].Max == 0) {
                    var check = CRSData[i].Max();
                    $("#lblMaxValValidation_" + CRSData[i].Id).text("Maximum value can not be left blank.");
                    $("#lblMaxValValidation_" + CRSData[i].Id).show();
                    $("#lblDescValidation_" + CRSData[i].Id).hide();
                    ValidationResult++;
                }
                else if (CRSData[i].Max < 0 || CRSData[i].Max > 100) {

                    $("#lblMaxValValidation_" + CRSData[i].Id).text("Maximum value should be between 0 and 100.");
                    $("#lblMaxValValidation_" + CRSData[i].Id).show();
                    $("#lblDescValidation_" + CRSData[i].Id).hide();
                    ValidationResult++;
                }
                else if (CRSData[i].Max < CRSData[i].Min) {

                    $("#lblMaxValValidation_" + CRSData[i].Id).text("Maximum value can not be less than Minimum value.");
                    $("#lblMaxValValidation_" + CRSData[i].Id).show();
                    $("#lblDescValidation_" + CRSData[i].Id).hide();
                    ValidationResult++;
                }
                else if (isNaN(CRSData[i].Min)) {
                    $("#lblMaxValValidation_" + CRSData[i].Id).text("Minimum value should only be a number.");
                    $("#lblMaxValValidation_" + CRSData[i].Id).show();
                    $("#lblDescValidation_" + CRSData[i].Id).hide();
                    ValidationResult++;
                }
                else if (!$.isNumeric(CRSData[i].Min)) {
                    $("#lblMaxValValidation_" + CRSData[i].Id).text("Minimum value should only be a number.");
                    $("#lblMaxValValidation_" + CRSData[i].Id).show();
                    $("#lblDescValidation_" + CRSData[i].Id).hide();
                    ValidationResult++;
                }

                else if (DescValidation > 0) {
                    $("#lblDescValidation_" + CRSData[i].Id).text("Description cannot be a duplicate.");
                    $("#lblDescValidation_" + CRSData[i].Id).show();
                    $("#lblMaxValValidation_" + CRSData[i].Id).hide();
                    ValidationResult++;
                }
                else if (CRSData[i].Description == "") {
                    $("#lblDescValidation_" + CRSData[i].Id).text("Description cannot be left blank.");
                    $("#lblDescValidation_" + CRSData[i].Id).show();
                    $("#lblMaxValValidation_" + CRSData[i].Id).hide();
                    ValidationResult++;
                }

                else {

                    $("#lblDescValidation_" + CRSData[i].Id).hide();
                    $("#lblMaxValValidation_" + CRSData[i].Id).hide();
                    $('#lblCommonValidation').hide();
                }
            }


            if (ValidationResult > 0)
                return false;
            else
                return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSValidate() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function CRSDataModel(item) {
        try {

            var self = this;
            self.Min = ko.observable(item.Min);
            self.Max = ko.observable(item.Max);
            self.Comments = ko.observable($('<div/>').html(item.Comments).text());
            self.Id = ko.observable(item.Id);
            self.Description = ko.observable($('<div/>').html(item.Description).text());
            self.CSS = ko.observable($('<div/>').html(item.CSS).text());
            self.Adjustment = ko.observable(item.Adjustment);
            if (RlViewModel.AddNewLevelCount() == -1) {
                self.Flag = ko.observable('');
            }
            else {
                self.Flag = ko.observable(item.Flag);
            }
            var ImagePath = self.CSS() + '.png';
            var CompletePath = '../../../Content/images/';

            self.imagePath = ko.observable((CompletePath).concat(ImagePath));

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSDataModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function CRSColorPalette(item) {
        try {
            var self = this;
            self.RiskLevelCSS = ko.observable($('<div/>').html(item.RiskLevelCss).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CRSColorPalette() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------------------------------ Logic for Qualitative Risk Level Starts here----------------------------------------------------------------------------------------------

    function QRSStart(TabName) {
        try {
            if (TabName == "Qualitative Data Risk Setup - AML")
                ko.applyBindingsToNode($('#QualitativeMain').get(0), { compose: 'viewmodels/configuration/AMLQualitativeSetup' });
            else
                ko.applyBindingsToNode($('#QualitativeMain').get(0), { compose: 'viewmodels/configuration/BusinessUnit' });
            $('#tabsQualitative').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QRSStart() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function RiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelName = item.RiskLevelName;
            self.RiskLevelShortText = item.RiskLevelShortText;
            self.ApplicableZATIds = item.ApplicableZATIds;
            self.ApplicableZATNames = item.ApplicableZATNames;
            self.ScoringType = item.ScoringType;
            self.LevelCount = item.RiskLevelCount;
            self.ScaleType = item.ScaleType;
            self.Type = item.Type;
            self.AssessmentId = item.AssessmentId;
            self.isQuantitative = item.isQuantitative;
            self.RiskLevelShortName = item.RiskLevelShortName;
            self.isFinal = item.isFinal;
            self.MappedRiskLevels = $.map(item.RiskLevelDetailsModel, function (result) {
                return new InherentRiskLevelModel(result);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QRSStart() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function InherentRiskLevelModel(item) {
        try {
            var self = this;
            self.Id = item.Id;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelParentId = item.RiskLevelParentId;
            self.CSS = item.CSS;
            self.RiskLevelShortName = item.RiskLevelShortName;
            self.RiskLevelAdj = item.RiskLevelAdj;
            self.RiskLevelComents = item.RiskLevelComents;
            self.RiskLevelDescription = item.RiskLevelDescription;
            self.RiskLevel = item.RiskLevel;
            self.RiskLevelcss = item.CSS;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskLevelModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ControlsParentRiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelName = item.RiskLevelName;
            self.RiskLevelShortName = item.RiskLevelShortName;
            self.RiskLevelAdj = item.RiskLevelAdj;
            self.RiskLevelShortText = item.RiskLevelShortText;
            self.AssessmentId = item.AssessmentId;
            self.Type = item.Type;
            self.ScaleType = item.ScaleType;
            var MappedcontrolLevels = $.map(item.ControlRiskSetupModel, function (result) {
                return new ControlsRiskLevelModel(result);
            });
            self.MappedRiskLevels = MappedcontrolLevels;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlsParentRiskLevelModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function ResidualParentRiskLevelModel(item) {
        try {
            var self = this;
            self.RRLId = item.RRLId;
            self.RRLName = item.RRLName;
            self.RRLShortName = item.RRLShortName;
            self.AssessmentId = item.AssessmentId;
            self.RiskLevelShortName = item.RiskLevelShortName;
            self.RiskLevelAdj = item.RiskLevelAdj;
            var MappedResidualLevels = $.map(item.ResidualRiskLevelsList, function (result) {
                return new ResidualRiskLevelModel(result);
            });
            self.MappedRiskLevels = ko.observableArray(MappedResidualLevels);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResidualParentRiskLevelModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ControlsRiskLevelModel(item) {
        try {
            var self = this;
            self.RowId = item.RowId;
            self.Id = item.Id;
            self.RiskLevelParentId = item.RiskLevelParentId;
            self.CSS = item.CSS;
            self.Comments = item.Comments;
            self.Description = item.Description;
            self.Min = item.Min;
            self.Max = item.Max;
            self.RiskLevelCSS = item.CSS;
            self.RiskLevelShortName= item.RiskLevelShortName
                self.RiskLevelAdj = item.RiskLevelAdj 
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlsRiskLevelModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function ResidualRiskLevelModel(item) {
        try {
            var self = this;
            self.Id = item.Id;
            self.RiskLevelParentId = item.RiskLevelParentId;
            self.CSS = item.CSS;
            self.Comments = item.Comments;
            self.Description = item.Description;
            self.RRLRiskScore = item.RRLRiskScore;
            self.RiskLevelShortName = item.RiskLevelShortName;
            self.RiskLevelAdj = item.RiskLevelAdj;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResidualRiskLevelModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function MasterParentRiskMatrixModel(item) {
        try {

            var self = this;
            self.ResidualMatrixId = item.ResidualMatrixId;
            self.ResidualMatrixName = item.ResidualMatrixName;
            self.XAxisType = item.XAxisType;
            self.YAxisType = item.YAxisType;
            self.XAxisName = item.XAxisName;
            self.YAxisName = item.YAxisName;
            self.ResidualName = item.ResidualName;
            //map x axis levels
            var mappedXaxisLevels = $.map(item.XAxisLevels, function (result) {
                return new AxisLevelModel(result);
            });
            self.XAxisLevels = ko.observableArray(mappedXaxisLevels);
            //map y axis levels
            var mappedYaxisLevels = $.map(item.YAxisLevels, function (result) {
                return new AxisLevelModel(result);
            });
            self.YAxisLevels = ko.observableArray(mappedYaxisLevels);

            //Residual dropdown list
            var mappedResidualLevelListData = $.map(item.ReisdualLevels, function (result) {
                return new ResidualScoreModel(result);
            });
            self.ReisdualLevels = ko.observableArray(mappedResidualLevelListData);

            //Selected Residual dropdown option values
            var mappedSelectedResLevelListData = $.map(item.ReisdualSectedLevelList, function (result) {
                return new ResidualCrossMatrixModel(result);
            });
            self.ReisdualSectedLevelList = ko.observableArray(mappedSelectedResLevelListData);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: MasterParentRiskMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function InherentMasterParentRiskMatrixModel(item) {
        try {

            var self = this;
            self.InherentMatrixId = item.InherentMatrixId;
            self.InherentMatrixName = item.InherentMatrixName;
            self.XAxisType = item.XAxisType;
            self.YAxisType = item.YAxisType;
            self.XAxisName = item.XAxisName;
            self.YAxisName = item.YAxisName;
            self.InherentAxisName = item.InherentAxisName;
            //map x axis levels
            var mappedXaxisLevels = $.map(item.XAxisLevels, function (result) {
                return new AxisLevelModel(result);
            });
            self.XAxisLevels = ko.observableArray(mappedXaxisLevels);
            //map y axis levels
            var mappedYaxisLevels = $.map(item.YAxisLevels, function (result) {
                return new AxisLevelModel(result);
            });
            self.YAxisLevels = ko.observableArray(mappedYaxisLevels);

            //Residual dropdown list
            var mappedInherentLevelListData = $.map(item.InherentLevels, function (result) {
                return new InherentScoreModel(result);
            });
            self.InherentLevels = ko.observableArray(mappedInherentLevelListData);

            //Selected Residual dropdown option values
            var mappedSelectedInhLevelListData = $.map(item.InherentSectedLevelList, function (result) {
                return new InherentCrossMatrixModel(result);
            });
            self.InherentSectedLevelList = ko.observableArray(mappedSelectedInhLevelListData);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentMasterParentRiskMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }



    function ControlMasterParentRiskMatrixModel(item) {
        try {

            var self = this;
            self.ControlMatrixId = item.ControlMatrixId;
            self.ControlMatrixName = item.ControlMatrixName;
            self.XAxisType = item.XAxisType;
            self.YAxisType = item.YAxisType;
            self.XAxisName = item.XAxisName;
            self.YAxisName = item.YAxisName;
            self.ControlAxisName = item.ControlAxisName;
            self.XPercentage = item.XPercentage;
            self.YPercentage = item.YPercentage;
            //map x axis levels
            var mappedXaxisLevels = $.map(item.XAxisLevels, function (result) {
                return new AxisLevelModel(result);
            });
            self.XAxisLevels = ko.observableArray(mappedXaxisLevels);
            //map y axis levels
            var mappedYaxisLevels = $.map(item.YAxisLevels, function (result) {
                return new AxisLevelModel(result);
            });
            self.YAxisLevels = ko.observableArray(mappedYaxisLevels);

            //Final dropdown list
            var mappedControlLevelListData = $.map(item.ControlLevels, function (result) {
                return new ControlScoreModel(result);
            });
            self.ControlLevels = ko.observableArray(mappedControlLevelListData);

            //Selected Residual dropdown option values
            var mappedSelectedCtrlLevelListData = $.map(item.ControlSectedLevelList, function (result) {
                return new ControlCrossMatrixModel(result);
            });
            self.ControlSectedLevelList = ko.observableArray(mappedSelectedCtrlLevelListData);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlMasterParentRiskMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }


    function AxisLevelModel(item) {
        try {
            var self = this;
            self.LevelId = ko.observable(item.LevelId);
            self.LevelName = ko.observable($('<div/>').html(item.LevelName).text());
            self.RiskCSS = ko.observable(item.RiskCSS);
            self.LowerBound = ko.observable(item.LowerBound);
            self.UpperBound = ko.observable(item.UpperBound);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AxisLevelModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }


    function InherentCrossMatrixModel(item) {
        try {
            var self = this;
            self.InherentMatrixId = item.InherentMatrixId;
            self.InherentMatrixName = item.InherentMatrixName;
            self.XAxisId = item.XAxisId;
            self.YAxisId = item.YAxisId;
            self.InherentAxisId = item.InherentAxisId;
            self.RiskCSS = item.RiskCSS; //For dropdown list only
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentCrossMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ControlCrossMatrixModel(item) {
        try {
            var self = this;
            self.ControlMatrixId = item.ControlMatrixId;
            self.ControlMatrixName = item.ControlMatrixName;
            self.XAxisId = item.XAxisId;
            self.YAxisId = item.YAxisId;
            self.XPercentage = item.XPercentage;
            self.YPercentage = item.YPercentage;
            self.ControlAxisId = item.ControlAxisId;
            self.RiskCSS = item.RiskCSS; //For dropdown list only
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlCrossMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }


    function ResidualCrossMatrixModel(item) {
        try {
            var self = this;
            self.ResidualMatrixId = item.ResidualMatrixId;
            self.ResidualMatrixName = item.ResidualMatrixName;
            self.XAxisId = item.XAxisId;
            self.YAxisId = item.YAxisId;
            self.ResidualAxisId = item.ResidualAxisId;
            self.RiskCSS = item.RiskCSS; //For dropdown list only
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResidualCrossMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function AxisModel(item) {
        try {
            var self = this;
            self.AxisId = item.AxisId;
            self.AxisName = item.AxisName;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AxisModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function ResidualScoreModel(item) {
        try {
            var self = this;
            self.LevelId = item.LevelId;
            self.LevelName = item.LevelName;
            self.RiskCSS = item.RiskCSS;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResidualScoreModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function InherentScoreModel(item) {
        try {
            var self = this;
            self.LevelId = item.LevelId;
            self.LevelName = item.LevelName;
            self.RiskCSS = item.RiskCSS;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentScoreModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function ControlScoreModel(item) {
        try {
            var self = this;
            self.LevelId = item.LevelId;
            self.LevelName = item.LevelName;
            self.RiskCSS = item.RiskCSS;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlScoreModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function SelectedScoreMatrixModel(item) {
        try {
            var self = this;
            self.XValue = item.XValue;
            self.YValue = item.YValue;
            self.ResScore = item.ResScore;
            self.RiskCSS = item.RiskCSS;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectedScoreMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SelectedInherentScoreMatrixModel(item) {
        try {
            var self = this;
            self.XValue = item.XValue;
            self.YValue = item.YValue;
            self.InhScore = item.InhScore;
            self.RiskCSS = item.RiskCSS;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectedInherentScoreMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }
    function SelectedControlScoreMatrixModel(item) {
        try {
            var self = this;
            self.XValue = item.XValue;
            self.YValue = item.YValue;
            self.CtrlScore = item.CtrlScore;
            self.RiskCSS = item.RiskCSS;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SelectedControlScoreMatrixModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function ResponseDataModel(item) {
        try {
            var self = this;
            self.ControlsResponseType = ko.observable($('<div/>').html(item.Response).text());
            self.ControlsResponseTypeId = ko.observable(item.Id);
            self.CalculationApplicability = ko.observable(item.CalculationApplicability);
            self.ratingApplicability = ko.observable(item.ratingApplicability);
            if (item.CalculationApplicability) {
                self.Score = ko.observable(item.Score);
                self.CalculationApplicability = ko.observable(1);
            }
            else {
                self.Score = ko.observable(item.Score);
                self.CalculationApplicability = ko.observable(0);
            }
            self.Flag = ko.observable(item.Flag);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResponseDataModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.Applicability = ko.observable(item.Applicability);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in RiskLevel.js';
            logger.logMessage(msg);
        }
    }

});


